export const faceMeshPrediction =
[
    {
        "faceInViewConfidence": 1,
        "boundingBox": {
            "topLeft": [
                29.73206007649418,
                24.636753528032827
            ],
            "bottomRight": [
                205.47925730098302,
                243.20026945427776
            ]
        },
        "mesh": [
            [
                96.88905334472656,
                121.66732025146484,
                -15.517449378967285
            ],
            [
                96.50823974609375,
                104.96472930908203,
                -31.441082000732422
            ],
            [
                96.52411651611328,
                109.83221435546875,
                -15.925427436828613
            ],
            [
                91.24686431884766,
                87.81340026855469,
                -24.509450912475586
            ],
            [
                96.45406341552734,
                99.77384948730469,
                -33.76573181152344
            ],
            [
                96.37386322021484,
                92.7978515625,
                -31.750505447387695
            ],
            [
                96.17317962646484,
                76.05583190917969,
                -16.971519470214844
            ],
            [
                54.356082916259766,
                74.47137451171875,
                6.463442802429199
            ],
            [
                96.12010192871094,
                64.78775787353516,
                -13.91344928741455
            ],
            [
                96.13843536376953,
                58.14468765258789,
                -15.722373008728027
            ],
            [
                95.97990417480469,
                31.961870193481445,
                -10.692856788635254
            ],
            [
                96.91658020019531,
                124.17359161376953,
                -14.53830623626709
            ],
            [
                96.9414291381836,
                125.96327209472656,
                -12.432847023010254
            ],
            [
                96.93336486816406,
                126.59907531738281,
                -9.63233757019043
            ],
            [
                96.99761962890625,
                126.1929931640625,
                -9.164018630981445
            ],
            [
                97.02291870117188,
                128.228759765625,
                -10.06065845489502
            ],
            [
                97.0439224243164,
                130.86849975585938,
                -11.298519134521484
            ],
            [
                97.04920196533203,
                133.76828002929688,
                -10.431467056274414
            ],
            [
                96.99334716796875,
                138.96441650390625,
                -4.465573787689209
            ],
            [
                96.51509094238281,
                107.44694519042969,
                -28.27605438232422
            ],
            [
                90.94851684570312,
                106.8481674194336,
                -20.059839248657227
            ],
            [
                34.469852447509766,
                55.00821304321289,
                32.993343353271484
            ],
            [
                71.25131225585938,
                78.82921600341797,
                0.6521462202072144
            ],
            [
                65.46626281738281,
                79.2551040649414,
                0.9860450625419617
            ],
            [
                59.89583969116211,
                79.04279327392578,
                2.5710299015045166
            ],
            [
                52.46076965332031,
                76.36002349853516,
                7.432613849639893
            ],
            [
                76.09359741210938,
                77.5961685180664,
                1.1813251972198486
            ],
            [
                63.06586837768555,
                67.55989074707031,
                -2.45806622505188
            ],
            [
                69.23617553710938,
                67.75996398925781,
                -2.3722519874572754
            ],
            [
                57.42295455932617,
                68.18559265136719,
                -0.4704916477203369
            ],
            [
                53.6713752746582,
                69.5871353149414,
                2.085986852645874
            ],
            [
                48.066162109375,
                79.56268310546875,
                10.611681938171387
            ],
            [
                75.28349304199219,
                147.4093780517578,
                3.218700408935547
            ],
            [
                52.32074737548828,
                73.30224609375,
                8.296472549438477
            ],
            [
                32.41441345214844,
                76.71810150146484,
                36.84736633300781
            ],
            [
                41.663047790527344,
                76.18025970458984,
                16.3133487701416
            ],
            [
                67.24018859863281,
                99.76070404052734,
                -3.664538860321045
            ],
            [
                89.67450714111328,
                120.8004150390625,
                -14.824533462524414
            ],
            [
                90.8922119140625,
                125.82820129394531,
                -11.570318222045898
            ],
            [
                82.37834167480469,
                122.13937377929688,
                -11.334951400756836
            ],
            [
                77.89507293701172,
                123.98145294189453,
                -7.061762809753418
            ],
            [
                85.59326171875,
                125.90985107421875,
                -9.34593391418457
            ],
            [
                81.54109191894531,
                126.24662780761719,
                -5.432833671569824
            ],
            [
                70.86996459960938,
                130.7681427001953,
                2.2824153900146484
            ],
            [
                91.56340789794922,
                104.75675201416016,
                -30.981788635253906
            ],
            [
                90.6953125,
                99.79730224609375,
                -33.08343505859375
            ],
            [
                44.59383010864258,
                64.29601287841797,
                3.352301597595215
            ],
            [
                78.57952880859375,
                87.05973815917969,
                -5.380341529846191
            ],
            [
                77.44502258300781,
                102.84845733642578,
                -16.322824478149414
            ],
            [
                77.10314178466797,
                100.06961822509766,
                -14.614078521728516
            ],
            [
                50.2843017578125,
                99.11561584472656,
                3.8229551315307617
            ],
            [
                90.93672943115234,
                93.31185913085938,
                -29.876455307006836
            ],
            [
                57.981082916259766,
                59.751060485839844,
                -7.434006690979004
            ],
            [
                49.958335876464844,
                61.10142517089844,
                -2.683871269226074
            ],
            [
                39.33524703979492,
                46.21135711669922,
                20.62157440185547
            ],
            [
                83.75399780273438,
                63.904693603515625,
                -12.143393516540527
            ],
            [
                74.74644470214844,
                69.05620574951172,
                -0.4041958451271057
            ],
            [
                66.35028076171875,
                126.42735290527344,
                3.558194637298584
            ],
            [
                39.11125183105469,
                122.67787170410156,
                56.44671630859375
            ],
            [
                81.8173599243164,
                105.59742736816406,
                -13.803557395935059
            ],
            [
                86.86859130859375,
                107.30774688720703,
                -14.344883918762207
            ],
            [
                72.91903686523438,
                126.53924560546875,
                2.833859443664551
            ],
            [
                75.5688705444336,
                126.21790313720703,
                1.166368007659912
            ],
            [
                46.7426643371582,
                57.521820068359375,
                0.07799241691827774
            ],
            [
                77.35209655761719,
                104.97599029541016,
                -12.873170852661133
            ],
            [
                69.0284652709961,
                60.366432189941406,
                -10.738887786865234
            ],
            [
                67.85704803466797,
                55.948726654052734,
                -12.233930587768555
            ],
            [
                61.874977111816406,
                34.53463363647461,
                -3.0586788654327393
            ],
            [
                43.191341400146484,
                51.57044219970703,
                8.794507026672363
            ],
            [
                65.49451446533203,
                44.74022674560547,
                -8.085357666015625
            ],
            [
                41.256378173828125,
                61.835323333740234,
                8.388497352600098
            ],
            [
                37.93558883666992,
                58.596988677978516,
                19.879026412963867
            ],
            [
                90.18020629882812,
                123.78108215332031,
                -13.889578819274902
            ],
            [
                84.2103500366211,
                124.51956176757812,
                -10.618358612060547
            ],
            [
                79.77301025390625,
                125.23068237304688,
                -6.742547512054443
            ],
            [
                83.38538360595703,
                106.52220153808594,
                -12.612524032592773
            ],
            [
                74.32235717773438,
                126.43766021728516,
                1.9455816745758057
            ],
            [
                76.81363677978516,
                126.89698791503906,
                -1.7215399742126465
            ],
            [
                76.17405700683594,
                125.91757202148438,
                0.9858667850494385
            ],
            [
                84.97785949707031,
                104.16719818115234,
                -22.288898468017578
            ],
            [
                82.70356750488281,
                125.8824462890625,
                -4.4183478355407715
            ],
            [
                86.81397247314453,
                126.0882568359375,
                -6.930975914001465
            ],
            [
                91.65570831298828,
                126.36531066894531,
                -8.986292839050293
            ],
            [
                89.53484344482422,
                138.72727966308594,
                -4.299275875091553
            ],
            [
                90.12271881103516,
                133.3596954345703,
                -10.10494613647461
            ],
            [
                90.47250366210938,
                130.34031677246094,
                -10.820045471191406
            ],
            [
                90.8807373046875,
                127.75635528564453,
                -9.478946685791016
            ],
            [
                91.32701110839844,
                126.07548522949219,
                -8.567123413085938
            ],
            [
                81.94225311279297,
                125.84176635742188,
                -4.173025131225586
            ],
            [
                81.14222717285156,
                126.47369384765625,
                -5.168166160583496
            ],
            [
                79.91676330566406,
                127.81454467773438,
                -5.964234352111816
            ],
            [
                78.78353118896484,
                129.57005310058594,
                -4.8553571701049805
            ],
            [
                72.58678436279297,
                118.10877990722656,
                -5.486203670501709
            ],
            [
                33.031272888183594,
                98.20464324951172,
                63.382606506347656
            ],
            [
                96.5029067993164,
                108.35462188720703,
                -20.233341217041016
            ],
            [
                79.26950073242188,
                125.93999481201172,
                -1.2219537496566772
            ],
            [
                78.17131805419922,
                126.2378921508789,
                -1.8423174619674683
            ],
            [
                88.96776580810547,
                109.67414855957031,
                -14.380467414855957
            ],
            [
                79.54471588134766,
                108.03103637695312,
                -8.347593307495117
            ],
            [
                87.94859313964844,
                108.55535888671875,
                -14.535599708557129
            ],
            [
                72.60872650146484,
                89.98978424072266,
                -3.0794074535369873
            ],
            [
                63.392730712890625,
                93.3852767944336,
                -1.1869419813156128
            ],
            [
                76.24622344970703,
                102.21067810058594,
                -11.090539932250977
            ],
            [
                47.88542556762695,
                39.19397735595703,
                7.792771816253662
            ],
            [
                51.84324645996094,
                46.69438552856445,
                -0.2639492452144623
            ],
            [
                55.84058380126953,
                55.34646987915039,
                -6.5636701583862305
            ],
            [
                75.83930206298828,
                133.7894287109375,
                -0.4909457564353943
            ],
            [
                81.75245666503906,
                57.17481994628906,
                -15.053000450134277
            ],
            [
                79.76268005371094,
                44.416114807128906,
                -12.567231178283691
            ],
            [
                77.4295883178711,
                32.35185623168945,
                -9.285161972045898
            ],
            [
                55.13946533203125,
                78.15579986572266,
                5.074185848236084
            ],
            [
                42.15607452392578,
                83.120849609375,
                14.128241539001465
            ],
            [
                79.13967895507812,
                76.35543060302734,
                1.951482892036438
            ],
            [
                47.473167419433594,
                70.52664184570312,
                7.281842231750488
            ],
            [
                82.65222930908203,
                83.82294464111328,
                -7.745715141296387
            ],
            [
                81.09230041503906,
                101.1870346069336,
                -22.29972267150879
            ],
            [
                36.4798698425293,
                86.4115982055664,
                20.95701026916504
            ],
            [
                46.055450439453125,
                86.73570251464844,
                8.991997718811035
            ],
            [
                53.42916488647461,
                88.66547393798828,
                3.621450185775757
            ],
            [
                64.35436248779297,
                87.84905242919922,
                0.8515294194221497
            ],
            [
                72.35731506347656,
                85.70236206054688,
                -0.5027655363082886
            ],
            [
                78.32108306884766,
                83.31388092041016,
                -2.2888076305389404
            ],
            [
                90.50865936279297,
                77.35257720947266,
                -14.591021537780762
            ],
            [
                37.54144287109375,
                96.98616027832031,
                20.005657196044922
            ],
            [
                42.78496170043945,
                69.67362213134766,
                9.942222595214844
            ],
            [
                93.54434204101562,
                107.20256805419922,
                -27.970314025878906
            ],
            [
                79.08734893798828,
                92.10707092285156,
                -7.453750133514404
            ],
            [
                31.40673065185547,
                76.07955169677734,
                56.982357025146484
            ],
            [
                82.80613708496094,
                80.67058563232422,
                -3.3605034351348877
            ],
            [
                75.86227416992188,
                102.42919921875,
                -4.981838703155518
            ],
            [
                50.57858657836914,
                73.70650482177734,
                9.441862106323242
            ],
            [
                80.80387115478516,
                97.80675506591797,
                -20.17717742919922
            ],
            [
                35.02608871459961,
                110.14899444580078,
                61.52238845825195
            ],
            [
                78.97085571289062,
                74.46482849121094,
                3.352165937423706
            ],
            [
                85.7630844116211,
                95.03227996826172,
                -26.20445442199707
            ],
            [
                50.613853454589844,
                135.33340454101562,
                25.06099510192871
            ],
            [
                51.25689697265625,
                140.5896453857422,
                36.33062744140625
            ],
            [
                32.87723159790039,
                97.81319427490234,
                41.55708694458008
            ],
            [
                43.7294807434082,
                128.31228637695312,
                32.29217529296875
            ],
            [
                35.08852005004883,
                66.8676986694336,
                30.00312042236328
            ],
            [
                73.9351577758789,
                152.71160888671875,
                7.207530498504639
            ],
            [
                94.12956237792969,
                108.10356140136719,
                -19.846384048461914
            ],
            [
                74.0048828125,
                95.79573822021484,
                -5.005223274230957
            ],
            [
                37.1193962097168,
                76.9845199584961,
                22.31523323059082
            ],
            [
                60.17454528808594,
                76.02286529541016,
                2.9976553916931152
            ],
            [
                65.26226043701172,
                76.43805694580078,
                1.5670009851455688
            ],
            [
                75.3436508178711,
                127.91382598876953,
                -0.6582879424095154
            ],
            [
                38.82893753051758,
                106.97090911865234,
                22.738571166992188
            ],
            [
                84.66053009033203,
                159.8608856201172,
                9.442840576171875
            ],
            [
                67.14049530029297,
                152.52679443359375,
                20.864992141723633
            ],
            [
                59.711368560791016,
                147.59788513183594,
                27.581401824951172
            ],
            [
                96.09144592285156,
                44.61960220336914,
                -13.732177734375
            ],
            [
                96.96417236328125,
                160.83433532714844,
                7.82768440246582
            ],
            [
                70.17989349365234,
                76.10002136230469,
                1.3127632141113281
            ],
            [
                74.77557373046875,
                75.32781219482422,
                2.090876579284668
            ],
            [
                77.63449096679688,
                74.90071868896484,
                3.2671499252319336
            ],
            [
                38.93904495239258,
                68.46488952636719,
                15.952875137329102
            ],
            [
                73.91620635986328,
                71.2146224975586,
                0.8912844657897949
            ],
            [
                68.88397979736328,
                70.04759216308594,
                -0.30966195464134216
            ],
            [
                63.786705017089844,
                69.82418823242188,
                -0.07610031962394714
            ],
            [
                58.71953582763672,
                70.56439208984375,
                1.414997935295105
            ],
            [
                55.55774688720703,
                71.73246002197266,
                3.4739134311676025
            ],
            [
                32.08042907714844,
                64.38604736328125,
                46.31218338012695
            ],
            [
                56.70846939086914,
                75.2559814453125,
                4.874054908752441
            ],
            [
                96.63704681396484,
                113.46974182128906,
                -14.42333984375
            ],
            [
                77.40675354003906,
                115.2442626953125,
                -8.648452758789062
            ],
            [
                81.64158630371094,
                104.86223602294922,
                -16.18877601623535
            ],
            [
                88.57138061523438,
                113.83177185058594,
                -13.966086387634277
            ],
            [
                96.11095428466797,
                70.1791763305664,
                -13.102889060974121
            ],
            [
                58.22382354736328,
                142.13829040527344,
                19.43720054626465
            ],
            [
                65.74630737304688,
                147.49200439453125,
                13.639209747314453
            ],
            [
                84.33970642089844,
                156.3370819091797,
                1.589878797531128
            ],
            [
                44.73724365234375,
                132.8252410888672,
                47.04523849487305
            ],
            [
                77.41400909423828,
                73.07647705078125,
                2.283372402191162
            ],
            [
                86.6465835571289,
                85.3679428100586,
                -15.84511947631836
            ],
            [
                97.01715087890625,
                157.3147735595703,
                0.29308897256851196
            ],
            [
                75.17828369140625,
                156.82569885253906,
                13.852992057800293
            ],
            [
                34.907920837402344,
                108.73902130126953,
                41.524314880371094
            ],
            [
                86.22964477539062,
                125.85952758789062,
                -6.6295881271362305
            ],
            [
                85.41416931152344,
                127.08499145507812,
                -7.716444492340088
            ],
            [
                84.56708526611328,
                129.08453369140625,
                -8.65229606628418
            ],
            [
                83.86929321289062,
                131.82554626464844,
                -7.856087684631348
            ],
            [
                81.9347152709961,
                136.62562561035156,
                -3.189915180206299
            ],
            [
                77.98649597167969,
                126.32026672363281,
                -1.972059965133667
            ],
            [
                76.21704864501953,
                125.99588012695312,
                -2.0849380493164062
            ],
            [
                74.49888610839844,
                125.2862548828125,
                -2.133786678314209
            ],
            [
                68.48206329345703,
                121.98275756835938,
                -1.1458740234375
            ],
            [
                46.216407775878906,
                109.79978942871094,
                10.758158683776855
            ],
            [
                86.67060852050781,
                80.27054595947266,
                -10.734211921691895
            ],
            [
                83.57421875,
                71.29385375976562,
                -1.216935396194458
            ],
            [
                79.92658233642578,
                72.03926086425781,
                1.0187095403671265
            ],
            [
                79.25733947753906,
                125.71194458007812,
                -1.3776367902755737
            ],
            [
                45.8331298828125,
                121.58705139160156,
                20.442808151245117
            ],
            [
                88.59534454345703,
                71.05754089355469,
                -8.91411018371582
            ],
            [
                78.37492370605469,
                141.9471893310547,
                0.3753073811531067
            ],
            [
                96.31094360351562,
                87.05290985107422,
                -26.551424026489258
            ],
            [
                90.77090454101562,
                82.81930541992188,
                -20.16622543334961
            ],
            [
                96.23965454101562,
                81.71674346923828,
                -21.563594818115234
            ],
            [
                82.51830291748047,
                93.30674743652344,
                -15.171625137329102
            ],
            [
                97.04450225830078,
                151.8512420654297,
                -3.4977939128875732
            ],
            [
                96.99708557128906,
                145.04440307617188,
                -3.897473096847534
            ],
            [
                87.4566879272461,
                144.64126586914062,
                -2.806584596633911
            ],
            [
                64.99508666992188,
                132.92599487304688,
                6.012148380279541
            ],
            [
                71.31491088867188,
                106.40618133544922,
                -3.5377821922302246
            ],
            [
                71.11700439453125,
                138.10935974121094,
                3.4219298362731934
            ],
            [
                58.36947250366211,
                105.60724639892578,
                -0.9838578104972839
            ],
            [
                66.32393646240234,
                111.42424774169922,
                -2.3644163608551025
            ],
            [
                53.70162582397461,
                113.6557388305664,
                4.215156555175781
            ],
            [
                85.315673828125,
                151.0675506591797,
                -1.9781476259231567
            ],
            [
                79.04234313964844,
                96.06774139404297,
                -10.71445083618164
            ],
            [
                59.90227127075195,
                136.69134521484375,
                12.082082748413086
            ],
            [
                67.54837799072266,
                142.40362548828125,
                8.489044189453125
            ],
            [
                60.23402786254883,
                126.89461517333984,
                6.409209728240967
            ],
            [
                40.512428283691406,
                115.40135192871094,
                25.44757652282715
            ],
            [
                53.00371170043945,
                127.33426666259766,
                12.592918395996094
            ],
            [
                37.99138259887695,
                118.86290740966797,
                39.700767517089844
            ],
            [
                62.11056900024414,
                118.03874206542969,
                0.7172022461891174
            ],
            [
                82.90589141845703,
                88.64418029785156,
                -11.32587718963623
            ],
            [
                83.06859588623047,
                103.41783905029297,
                -23.54264259338379
            ],
            [
                79.22998046875,
                104.4982681274414,
                -16.909927368164062
            ],
            [
                85.62178802490234,
                100.24762725830078,
                -28.041946411132812
            ],
            [
                78.89644622802734,
                67.70046997070312,
                -3.4346392154693604
            ],
            [
                69.37569427490234,
                65.37333679199219,
                -4.834954738616943
            ],
            [
                61.193084716796875,
                64.86236572265625,
                -4.4784393310546875
            ],
            [
                54.44193649291992,
                65.36788940429688,
                -1.9790793657302856
            ],
            [
                49.72846221923828,
                67.13973999023438,
                1.9282158613204956
            ],
            [
                46.721858978271484,
                74.91212463378906,
                11.854694366455078
            ],
            [
                31.814367294311523,
                87.17120361328125,
                39.506927490234375
            ],
            [
                51.18846130371094,
                81.735107421875,
                7.667500972747803
            ],
            [
                57.08796310424805,
                83.20592498779297,
                4.087185859680176
            ],
            [
                64.72337341308594,
                83.16597747802734,
                1.6742497682571411
            ],
            [
                71.96148681640625,
                81.97029876708984,
                0.673589825630188
            ],
            [
                77.55428314208984,
                80.32038116455078,
                0.2831626534461975
            ],
            [
                81.42117309570312,
                78.68070983886719,
                -0.14186634123325348
            ],
            [
                32.22128677368164,
                87.09062194824219,
                62.147132873535156
            ],
            [
                79.48214721679688,
                105.73018646240234,
                -13.852197647094727
            ],
            [
                86.64763641357422,
                90.04463958740234,
                -20.17110252380371
            ],
            [
                87.35403442382812,
                103.8311538696289,
                -28.159927368164062
            ],
            [
                90.64522552490234,
                106.19840240478516,
                -25.576139450073242
            ],
            [
                87.37178039550781,
                104.48599243164062,
                -25.221750259399414
            ],
            [
                81.26936340332031,
                107.2717514038086,
                -11.73967170715332
            ],
            [
                91.70814514160156,
                106.76451873779297,
                -27.14698600769043
            ],
            [
                92.24659729003906,
                107.69169616699219,
                -19.931026458740234
            ],
            [
                81.06329345703125,
                74.8885269165039,
                2.4417476654052734
            ],
            [
                84.44317626953125,
                76.03508758544922,
                -1.1111698150634766
            ],
            [
                86.23490142822266,
                76.86599731445312,
                -5.281299114227295
            ],
            [
                53.74531555175781,
                72.584716796875,
                5.60056209564209
            ],
            [
                50.829471588134766,
                71.1065902709961,
                5.686931610107422
            ],
            [
                101.38069152832031,
                87.84761047363281,
                -24.344675064086914
            ],
            [
                137.84046936035156,
                74.7665023803711,
                7.334073066711426
            ],
            [
                102.00772094726562,
                106.84516143798828,
                -19.964433670043945
            ],
            [
                157.12498474121094,
                55.322574615478516,
                34.3399772644043
            ],
            [
                121.05142974853516,
                79.00511932373047,
                1.2109861373901367
            ],
            [
                126.84400177001953,
                79.45388793945312,
                1.6804367303848267
            ],
            [
                132.37461853027344,
                79.25894927978516,
                3.355182409286499
            ],
            [
                139.6626434326172,
                76.6651382446289,
                8.357008934020996
            ],
            [
                116.2015609741211,
                77.71794891357422,
                1.6222927570343018
            ],
            [
                129.2057647705078,
                67.90971374511719,
                -1.762386679649353
            ],
            [
                123.01789855957031,
                68.0480728149414,
                -1.8313332796096802
            ],
            [
                134.7899169921875,
                68.55963134765625,
                0.3153851628303528
            ],
            [
                138.4729766845703,
                69.96411895751953,
                2.9880430698394775
            ],
            [
                144.02366638183594,
                79.76676177978516,
                11.560099601745605
            ],
            [
                118.45621490478516,
                147.3950958251953,
                3.607323408126831
            ],
            [
                139.84878540039062,
                73.65056610107422,
                9.194131851196289
            ],
            [
                159.2861785888672,
                76.9404525756836,
                38.25723648071289
            ],
            [
                150.3023681640625,
                76.43496704101562,
                17.4151554107666
            ],
            [
                125.51261901855469,
                99.77899169921875,
                -3.1244139671325684
            ],
            [
                104.08863067626953,
                120.75617980957031,
                -14.684042930603027
            ],
            [
                103.04364776611328,
                125.80819702148438,
                -11.481496810913086
            ],
            [
                111.45106506347656,
                122.06983947753906,
                -11.07283878326416
            ],
            [
                116.0486831665039,
                123.8776626586914,
                -6.6808929443359375
            ],
            [
                108.35124206542969,
                125.84732818603516,
                -9.141393661499023
            ],
            [
                112.47268676757812,
                126.13788604736328,
                -5.1382832527160645
            ],
            [
                123.04002380371094,
                130.66848754882812,
                2.7330069541931152
            ],
            [
                101.4339828491211,
                104.77227783203125,
                -30.886960983276367
            ],
            [
                102.21053314208984,
                99.81094360351562,
                -32.99831771850586
            ],
            [
                147.438720703125,
                64.76704406738281,
                4.355432033538818
            ],
            [
                113.89869689941406,
                87.10984802246094,
                -5.022059440612793
            ],
            [
                115.3954086303711,
                102.78469848632812,
                -15.905627250671387
            ],
            [
                115.64459991455078,
                100.01785278320312,
                -14.223589897155762
            ],
            [
                142.30184936523438,
                99.16728210449219,
                4.717921733856201
            ],
            [
                101.80733489990234,
                93.35018920898438,
                -29.777019500732422
            ],
            [
                134.1881866455078,
                60.22747802734375,
                -6.7318196296691895
            ],
            [
                142.11859130859375,
                61.601043701171875,
                -1.8263874053955078
            ],
            [
                152.33106994628906,
                46.530548095703125,
                21.765567779541016
            ],
            [
                108.56291198730469,
                64.08650970458984,
                -11.966418266296387
            ],
            [
                117.53255462646484,
                69.26460266113281,
                0.04886084049940109
            ],
            [
                127.50724029541016,
                126.29833984375,
                4.118580341339111
            ],
            [
                153.02792358398438,
                122.71842956542969,
                57.68179702758789
            ],
            [
                111.0857162475586,
                105.56036376953125,
                -13.513188362121582
            ],
            [
                106.08965301513672,
                107.27765655517578,
                -14.188481330871582
            ],
            [
                121.12015533447266,
                126.40143585205078,
                3.3114333152770996
            ],
            [
                118.46546173095703,
                126.04596710205078,
                1.582306146621704
            ],
            [
                145.29429626464844,
                58.07335662841797,
                0.986547589302063
            ],
            [
                115.49264526367188,
                104.88399505615234,
                -12.51405143737793
            ],
            [
                123.19449615478516,
                60.70401382446289,
                -10.279659271240234
            ],
            [
                124.38214111328125,
                56.32521438598633,
                -11.77291488647461
            ],
            [
                130.01194763183594,
                34.78087615966797,
                -2.4149906635284424
            ],
            [
                148.681884765625,
                51.979705810546875,
                9.850789070129395
            ],
            [
                126.58548736572266,
                45.0115966796875,
                -7.541848182678223
            ],
            [
                150.69915771484375,
                62.313838958740234,
                9.425344467163086
            ],
            [
                153.87283325195312,
                59.0015754699707,
                21.05847930908203
            ],
            [
                103.69818878173828,
                123.74324035644531,
                -13.785435676574707
            ],
            [
                109.7154769897461,
                124.43839263916016,
                -10.394638061523438
            ],
            [
                114.2365493774414,
                125.13383483886719,
                -6.418834209442139
            ],
            [
                109.54704284667969,
                106.47137451171875,
                -12.378215789794922
            ],
            [
                119.74258422851562,
                126.29737091064453,
                2.3482885360717773
            ],
            [
                117.29444885253906,
                126.80149841308594,
                -1.4060178995132446
            ],
            [
                117.87548065185547,
                125.76055145263672,
                1.3653502464294434
            ],
            [
                107.93557739257812,
                104.16096496582031,
                -22.044574737548828
            ],
            [
                111.26531982421875,
                125.78980255126953,
                -4.17445182800293
            ],
            [
                107.10684967041016,
                126.01599884033203,
                -6.739085674285889
            ],
            [
                102.26374816894531,
                126.34742736816406,
                -8.868383407592773
            ],
            [
                104.4036636352539,
                138.7237091064453,
                -4.20366096496582
            ],
            [
                103.9894790649414,
                133.3521728515625,
                -10.020724296569824
            ],
            [
                103.62567901611328,
                130.3445587158203,
                -10.736661911010742
            ],
            [
                103.16693115234375,
                127.75308990478516,
                -9.376955032348633
            ],
            [
                102.6659164428711,
                126.04779815673828,
                -8.436172485351562
            ],
            [
                112.0370864868164,
                125.75372314453125,
                -3.921337842941284
            ],
            [
                112.90324401855469,
                126.36920166015625,
                -4.9160075187683105
            ],
            [
                114.17613983154297,
                127.726806640625,
                -5.689537048339844
            ],
            [
                115.31583404541016,
                129.48928833007812,
                -4.585168361663818
            ],
            [
                120.98614501953125,
                118.01705932617188,
                -5.029215335845947
            ],
            [
                158.5799560546875,
                98.33074188232422,
                64.78570556640625
            ],
            [
                114.78053283691406,
                125.81948852539062,
                -0.8971143960952759
            ],
            [
                115.90477752685547,
                126.10759735107422,
                -1.508284330368042
            ],
            [
                104.0551528930664,
                109.66088104248047,
                -14.274346351623535
            ],
            [
                113.39496612548828,
                107.9499282836914,
                -8.02297592163086
            ],
            [
                105.02310943603516,
                108.53216552734375,
                -14.421208381652832
            ],
            [
                119.88191223144531,
                90.02860260009766,
                -2.6084320545196533
            ],
            [
                129.17185974121094,
                93.43110656738281,
                -0.5620904564857483
            ],
            [
                116.53067016601562,
                102.14347839355469,
                -10.690805435180664
            ],
            [
                143.8606719970703,
                39.5225715637207,
                8.728507041931152
            ],
            [
                140.07066345214844,
                47.087684631347656,
                0.6010512709617615
            ],
            [
                136.2898712158203,
                55.822017669677734,
                -5.846424579620361
            ],
            [
                118.10610961914062,
                133.7335968017578,
                -0.1538432538509369
            ],
            [
                110.54092407226562,
                57.387840270996094,
                -14.795687675476074
            ],
            [
                112.3628158569336,
                44.54645538330078,
                -12.23374080657959
            ],
            [
                114.52005004882812,
                32.50169372558594,
                -8.980547904968262
            ],
            [
                137.0618133544922,
                78.39363861083984,
                5.952434539794922
            ],
            [
                149.90347290039062,
                83.27507781982422,
                15.234307289123535
            ],
            [
                113.18206024169922,
                76.46823120117188,
                2.3601605892181396
            ],
            [
                144.56942749023438,
                70.91388702392578,
                8.25685977935791
            ],
            [
                109.8076400756836,
                83.88069915771484,
                -7.450784206390381
            ],
            [
                111.75577545166016,
                101.18412017822266,
                -21.97791290283203
            ],
            [
                155.56019592285156,
                86.53792572021484,
                22.228647232055664
            ],
            [
                146.1772003173828,
                86.86007690429688,
                10.01909351348877
            ],
            [
                138.97032165527344,
                88.75408172607422,
                4.479675769805908
            ],
            [
                128.09445190429688,
                87.92622375488281,
                1.5277549028396606
            ],
            [
                120.0620346069336,
                85.77826690673828,
                0.0027251075953245163
            ],
            [
                114.06951904296875,
                83.38709259033203,
                -1.9097141027450562
            ],
            [
                101.885498046875,
                77.37371826171875,
                -14.463367462158203
            ],
            [
                154.6912841796875,
                97.04508972167969,
                21.277406692504883
            ],
            [
                149.20399475097656,
                70.02367401123047,
                11.055558204650879
            ],
            [
                99.47708129882812,
                107.19630432128906,
                -27.890941619873047
            ],
            [
                113.47195434570312,
                92.13121795654297,
                -7.111136436462402
            ],
            [
                160.01100158691406,
                76.27710723876953,
                58.399478912353516
            ],
            [
                109.58899688720703,
                80.734619140625,
                -3.0669960975646973
            ],
            [
                116.87383270263672,
                102.34833526611328,
                -4.6022772789001465
            ],
            [
                141.4975128173828,
                74.06877136230469,
                10.382974624633789
            ],
            [
                111.95087432861328,
                97.79914093017578,
                -19.858644485473633
            ],
            [
                156.8252716064453,
                110.26105499267578,
                62.86159896850586
            ],
            [
                113.31108093261719,
                74.58332824707031,
                3.78249192237854
            ],
            [
                106.99674987792969,
                95.05940246582031,
                -25.971696853637695
            ],
            [
                142.5082244873047,
                135.3732452392578,
                25.987520217895508
            ],
            [
                141.6615447998047,
                140.64242553710938,
                37.32156753540039
            ],
            [
                159.07603454589844,
                97.94306182861328,
                42.94356155395508
            ],
            [
                149.02203369140625,
                128.36497497558594,
                33.36517333984375
            ],
            [
                156.64845275878906,
                67.16893768310547,
                31.325349807739258
            ],
            [
                119.76835632324219,
                152.69900512695312,
                7.603298187255859
            ],
            [
                98.83515930175781,
                108.11546325683594,
                -19.77289390563965
            ],
            [
                118.58689880371094,
                95.79483795166016,
                -4.5740065574646
            ],
            [
                154.7720184326172,
                77.22306060791016,
                23.570072174072266
            ],
            [
                132.1065673828125,
                76.25077056884766,
                3.7676494121551514
            ],
            [
                127.02445983886719,
                76.6551742553711,
                2.2459464073181152
            ],
            [
                118.7540054321289,
                127.8020248413086,
                -0.2979637086391449
            ],
            [
                153.55209350585938,
                106.99690246582031,
                23.911178588867188
            ],
            [
                109.16101837158203,
                159.84153747558594,
                9.644326210021973
            ],
            [
                126.31228637695312,
                152.53414916992188,
                21.40969467163086
            ],
            [
                133.5411376953125,
                147.63763427734375,
                28.352481842041016
            ],
            [
                122.12049102783203,
                76.28700256347656,
                1.867456316947937
            ],
            [
                117.51725006103516,
                75.45594787597656,
                2.602623462677002
            ],
            [
                114.63973236083984,
                75.02603912353516,
                3.724750280380249
            ],
            [
                152.9879608154297,
                68.79815673828125,
                17.10785484313965
            ],
            [
                118.36962127685547,
                71.40326690673828,
                1.3848233222961426
            ],
            [
                123.44576263427734,
                70.2990493774414,
                0.2953520715236664
            ],
            [
                128.53433227539062,
                70.1328125,
                0.5978397727012634
            ],
            [
                133.5772705078125,
                70.90018463134766,
                2.195375442504883
            ],
            [
                136.68357849121094,
                72.09175109863281,
                4.306293487548828
            ],
            [
                159.3648223876953,
                64.64537811279297,
                47.681251525878906
            ],
            [
                135.51588439941406,
                75.53532409667969,
                5.69104528427124
            ],
            [
                115.94859313964844,
                115.13328552246094,
                -8.315324783325195
            ],
            [
                111.24604797363281,
                104.83809661865234,
                -15.895578384399414
            ],
            [
                104.78147888183594,
                113.81010437011719,
                -13.83856201171875
            ],
            [
                135.1164093017578,
                142.16607666015625,
                20.150609970092773
            ],
            [
                127.79518127441406,
                147.48834228515625,
                14.23727035522461
            ],
            [
                109.5683822631836,
                156.3130340576172,
                1.7847367525100708
            ],
            [
                147.7564239501953,
                132.88880920410156,
                48.15724563598633
            ],
            [
                114.85303497314453,
                73.22557830810547,
                2.7306060791015625
            ],
            [
                105.90587615966797,
                85.40321350097656,
                -15.613755226135254
            ],
            [
                118.45579528808594,
                156.82839965820312,
                14.306870460510254
            ],
            [
                157.2328338623047,
                108.83926391601562,
                42.82856750488281
            ],
            [
                107.78206634521484,
                125.82642364501953,
                -6.409834861755371
            ],
            [
                108.63150024414062,
                127.0302505493164,
                -7.506717205047607
            ],
            [
                109.49678039550781,
                129.04295349121094,
                -8.487283706665039
            ],
            [
                110.22860717773438,
                131.77737426757812,
                -7.658293724060059
            ],
            [
                112.03075408935547,
                136.5821075439453,
                -2.9844183921813965
            ],
            [
                116.07954406738281,
                126.1829605102539,
                -1.6502294540405273
            ],
            [
                117.83755493164062,
                125.85551452636719,
                -1.678907871246338
            ],
            [
                119.53681945800781,
                125.12629699707031,
                -1.6933009624481201
            ],
            [
                125.28678894042969,
                121.8697738647461,
                -0.6240276098251343
            ],
            [
                146.50320434570312,
                109.81321716308594,
                11.702927589416504
            ],
            [
                105.74989318847656,
                80.30723571777344,
                -10.533944129943848
            ],
            [
                108.65938568115234,
                71.40918731689453,
                -0.9609823226928711
            ],
            [
                112.3184814453125,
                72.18851470947266,
                1.4397248029708862
            ],
            [
                114.76670837402344,
                125.55813598632812,
                -1.023319959640503
            ],
            [
                147.0255126953125,
                121.58879852294922,
                21.44499397277832
            ],
            [
                103.6593246459961,
                71.12564849853516,
                -8.767714500427246
            ],
            [
                115.43153381347656,
                141.91424560546875,
                0.6569437384605408
            ],
            [
                101.74317932128906,
                82.82658386230469,
                -20.06808090209961
            ],
            [
                110.09217071533203,
                93.33312225341797,
                -14.867352485656738
            ],
            [
                106.45712280273438,
                144.62222290039062,
                -2.6835858821868896
            ],
            [
                128.6868438720703,
                132.86398315429688,
                6.548011302947998
            ],
            [
                121.60697174072266,
                106.35923767089844,
                -3.0821075439453125
            ],
            [
                122.61885833740234,
                138.05718994140625,
                3.8108036518096924
            ],
            [
                134.54705810546875,
                105.63351440429688,
                -0.3275127112865448
            ],
            [
                126.90498352050781,
                111.3573226928711,
                -1.8075451850891113
            ],
            [
                139.33021545410156,
                113.65769958496094,
                4.934145927429199
            ],
            [
                108.59904479980469,
                151.06410217285156,
                -1.784031867980957
            ],
            [
                113.58834838867188,
                96.05381774902344,
                -10.349359512329102
            ],
            [
                133.56581115722656,
                136.67356872558594,
                12.764558792114258
            ],
            [
                126.0819320678711,
                142.39407348632812,
                8.999100685119629
            ],
            [
                133.3393096923828,
                126.8374252319336,
                7.078319072723389
            ],
            [
                152.0438690185547,
                115.41594696044922,
                26.575763702392578
            ],
            [
                140.24322509765625,
                127.32736206054688,
                13.39535140991211
            ],
            [
                154.39015197753906,
                118.93659210205078,
                40.92788314819336
            ],
            [
                131.3762664794922,
                117.97491455078125,
                1.3170418739318848
            ],
            [
                109.63031768798828,
                88.68263244628906,
                -11.025984764099121
            ],
            [
                109.83513641357422,
                103.37862396240234,
                -23.25238609313965
            ],
            [
                113.67141723632812,
                104.45024108886719,
                -16.600086212158203
            ],
            [
                107.26756286621094,
                100.25670623779297,
                -27.823015213012695
            ],
            [
                113.34941101074219,
                67.8879623413086,
                -3.07625675201416
            ],
            [
                122.88602447509766,
                65.70868682861328,
                -4.309804439544678
            ],
            [
                131.0209503173828,
                65.24516296386719,
                -3.7846388816833496
            ],
            [
                137.75099182128906,
                65.78691864013672,
                -1.116007685661316
            ],
            [
                142.358154296875,
                67.56503295898438,
                2.857253074645996
            ],
            [
                145.29161071777344,
                75.21650695800781,
                12.883472442626953
            ],
            [
                159.9520263671875,
                87.35105895996094,
                40.90973663330078
            ],
            [
                140.99044799804688,
                81.94963073730469,
                8.646967887878418
            ],
            [
                135.21070861816406,
                83.35963439941406,
                4.919290542602539
            ],
            [
                127.62309265136719,
                83.31615447998047,
                2.355144739151001
            ],
            [
                120.37972259521484,
                82.0892105102539,
                1.1949496269226074
            ],
            [
                114.77439880371094,
                80.41960906982422,
                0.6643215417861938
            ],
            [
                110.90805053710938,
                78.7662124633789,
                0.16929467022418976
            ],
            [
                159.2720947265625,
                87.23854064941406,
                63.57815933227539
            ],
            [
                113.43766784667969,
                105.68041229248047,
                -13.537425994873047
            ],
            [
                105.97980499267578,
                90.08078002929688,
                -19.901891708374023
            ],
            [
                105.63119506835938,
                103.85023498535156,
                -27.979829788208008
            ],
            [
                102.33496856689453,
                106.18894958496094,
                -25.450485229492188
            ],
            [
                105.57599639892578,
                104.5069580078125,
                -25.02594757080078
            ],
            [
                111.68846893310547,
                107.19316101074219,
                -11.47732925415039
            ],
            [
                101.3078384399414,
                106.76671600341797,
                -27.055374145507812
            ],
            [
                100.71078491210938,
                107.6917724609375,
                -19.87354278564453
            ],
            [
                111.2164535522461,
                75.00064849853516,
                2.8075015544891357
            ],
            [
                107.85000610351562,
                76.13240051269531,
                -0.8218579292297363
            ],
            [
                106.1072006225586,
                76.9287338256836,
                -5.076536178588867
            ],
            [
                138.45640563964844,
                72.9539794921875,
                6.463142395019531
            ],
            [
                141.2601318359375,
                71.48751068115234,
                6.624624252319336
            ]
        ],
        "scaledMesh": [
            [
                118.98641204833984,
                162.48776245117188,
                -15.517449378967285
            ],
            [
                118.52294158935547,
                143.6044921875,
                -31.441082000732422
            ],
            [
                118.57138061523438,
                149.10800170898438,
                -15.925427436828613
            ],
            [
                113.61085510253906,
                124.24127960205078,
                -24.509450912475586
            ],
            [
                118.4373550415039,
                137.73553466796875,
                -33.76573181152344
            ],
            [
                118.31560516357422,
                129.84829711914062,
                -31.750505447387695
            ],
            [
                118.01593017578125,
                110.91943359375,
                -16.971519470214844
            ],
            [
                79.91556549072266,
                109.36308288574219,
                6.463442802429199
            ],
            [
                117.888916015625,
                98.1790542602539,
                -13.91344928741455
            ],
            [
                117.85923767089844,
                90.66770935058594,
                -15.722373008728027
            ],
            [
                117.53205108642578,
                61.06400680541992,
                -10.692856788635254
            ],
            [
                119.02898406982422,
                165.32142639160156,
                -14.53830623626709
            ],
            [
                119.0641098022461,
                167.3448486328125,
                -12.432847023010254
            ],
            [
                119.06120300292969,
                168.0637969970703,
                -9.63233757019043
            ],
            [
                119.11689758300781,
                167.60427856445312,
                -9.164018630981445
            ],
            [
                119.1541519165039,
                169.9059600830078,
                -10.06065845489502
            ],
            [
                119.19171142578125,
                172.89056396484375,
                -11.298519134521484
            ],
            [
                119.21676635742188,
                176.16928100585938,
                -10.431467056274414
            ],
            [
                119.20216369628906,
                182.0447998046875,
                -4.465573787689209
            ],
            [
                118.5465087890625,
                146.4110565185547,
                -28.27605438232422
            ],
            [
                113.47199249267578,
                145.7653350830078,
                -20.059839248657227
            ],
            [
                61.66621398925781,
                87.46815490722656,
                32.993343353271484
            ],
            [
                95.33509063720703,
                114.19541931152344,
                0.6521462202072144
            ],
            [
                90.06871795654297,
                114.70950317382812,
                0.9860450625419617
            ],
            [
                84.99339294433594,
                114.50077056884766,
                2.5710299015045166
            ],
            [
                78.202392578125,
                111.50921630859375,
                7.432613849639893
            ],
            [
                99.73709869384766,
                112.77399444580078,
                1.1813251972198486
            ],
            [
                87.8006591796875,
                101.4993667602539,
                -2.45806622505188
            ],
            [
                93.42230987548828,
                101.69088745117188,
                -2.3722519874572754
            ],
            [
                82.66515350341797,
                102.23857879638672,
                -0.4704916477203369
            ],
            [
                79.25779724121094,
                103.8443832397461,
                2.085986852645874
            ],
            [
                74.2219009399414,
                115.15513610839844,
                10.611681938171387
            ],
            [
                99.4865951538086,
                191.71551513671875,
                3.218700408935547
            ],
            [
                78.05350494384766,
                108.0526123046875,
                8.296472549438477
            ],
            [
                59.94557189941406,
                112.02682495117188,
                36.84736633300781
            ],
            [
                68.36598205566406,
                111.36668395996094,
                16.3133487701416
            ],
            [
                91.82766723632812,
                137.8849639892578,
                -3.664538860321045
            ],
            [
                112.4089584350586,
                161.5481414794922,
                -14.824533462524414
            ],
            [
                113.55320739746094,
                167.2261505126953,
                -11.570318222045898
            ],
            [
                105.77255249023438,
                163.10311889648438,
                -11.334951400756836
            ],
            [
                101.7018051147461,
                165.21115112304688,
                -7.061762809753418
            ],
            [
                108.72720336914062,
                167.3482666015625,
                -9.34593391418457
            ],
            [
                105.03861999511719,
                167.75184631347656,
                -5.432833671569824
            ],
            [
                95.35033416748047,
                172.92428588867188,
                2.2824153900146484
            ],
            [
                114.01746368408203,
                143.3971405029297,
                -30.981788635253906
            ],
            [
                113.19213104248047,
                137.79443359375,
                -33.08343505859375
            ],
            [
                70.95252990722656,
                97.91282653808594,
                3.352301597595215
            ],
            [
                102.06748962402344,
                123.46035766601562,
                -5.380341529846191
            ],
            [
                101.14434051513672,
                141.31886291503906,
                -16.322824478149414
            ],
            [
                100.81353759765625,
                138.17877197265625,
                -14.614078521728516
            ],
            [
                76.3788070678711,
                137.2509307861328,
                3.8229551315307617
            ],
            [
                113.36675262451172,
                130.46006774902344,
                -29.876455307006836
            ],
            [
                83.1146469116211,
                92.69861602783203,
                -7.434006690979004
            ],
            [
                75.81651306152344,
                94.27057647705078,
                -2.683871269226074
            ],
            [
                66.03646850585938,
                77.49429321289062,
                20.62157440185547
            ],
            [
                106.61902618408203,
                97.25012969970703,
                -12.143393516540527
            ],
            [
                98.4504165649414,
                103.12554168701172,
                -0.4041958451271057
            ],
            [
                91.20325469970703,
                168.0416259765625,
                3.558194637298584
            ],
            [
                66.36627960205078,
                163.955322265625,
                56.44671630859375
            ],
            [
                105.14610290527344,
                144.40249633789062,
                -13.803557395935059
            ],
            [
                109.75897979736328,
                146.30792236328125,
                -14.344883918762207
            ],
            [
                97.18721771240234,
                168.13119506835938,
                2.833859443664551
            ],
            [
                99.59858703613281,
                167.75296020507812,
                1.166368007659912
            ],
            [
                72.86251068115234,
                90.24124145507812,
                0.07799241691827774
            ],
            [
                101.07455444335938,
                143.72496032714844,
                -12.873170852661133
            ],
            [
                93.18150329589844,
                93.332275390625,
                -10.738887786865234
            ],
            [
                92.08367156982422,
                88.34381866455078,
                -12.233930587768555
            ],
            [
                86.4853744506836,
                64.16480255126953,
                -3.0586788654327393
            ],
            [
                69.58622741699219,
                83.53206634521484,
                8.794507026672363
            ],
            [
                89.8534927368164,
                75.68379211425781,
                -8.085357666015625
            ],
            [
                67.89541625976562,
                95.14932250976562,
                8.388497352600098
            ],
            [
                64.84805297851562,
                91.50645446777344,
                19.879026412963867
            ],
            [
                112.890380859375,
                164.91549682617188,
                -13.889578819274902
            ],
            [
                107.4578628540039,
                165.78407287597656,
                -10.618358612060547
            ],
            [
                103.42105865478516,
                166.6130828857422,
                -6.742547512054443
            ],
            [
                106.58079528808594,
                145.43930053710938,
                -12.612524032592773
            ],
            [
                98.46472930908203,
                168.00845336914062,
                1.9455816745758057
            ],
            [
                100.73712921142578,
                168.5137939453125,
                -1.7215399742126465
            ],
            [
                100.1477279663086,
                167.40997314453125,
                0.9858667850494385
            ],
            [
                108.0148696899414,
                142.767578125,
                -22.288898468017578
            ],
            [
                106.09491729736328,
                167.3335418701172,
                -4.4183478355407715
            ],
            [
                109.84033966064453,
                167.54312133789062,
                -6.930975914001465
            ],
            [
                114.25239562988281,
                167.82916259765625,
                -8.986292839050293
            ],
            [
                112.40689849853516,
                181.81861877441406,
                -4.299275875091553
            ],
            [
                112.90489196777344,
                175.74624633789062,
                -10.10494613647461
            ],
            [
                113.2024154663086,
                172.33030700683594,
                -10.820045471191406
            ],
            [
                113.55622100830078,
                169.40635681152344,
                -9.478946685791016
            ],
            [
                113.95097351074219,
                167.50331115722656,
                -8.567123413085938
            ],
            [
                105.40119171142578,
                167.2918243408203,
                -4.173025131225586
            ],
            [
                104.67689514160156,
                168.01083374023438,
                -5.168166160583496
            ],
            [
                103.57003784179688,
                169.5338134765625,
                -5.964234352111816
            ],
            [
                102.55007934570312,
                171.52511596679688,
                -4.8553571701049805
            ],
            [
                96.82572937011719,
                158.60084533691406,
                -5.486203670501709
            ],
            [
                60.65744400024414,
                136.31793212890625,
                63.382606506347656
            ],
            [
                118.541748046875,
                147.4374237060547,
                -20.233341217041016
            ],
            [
                102.9673843383789,
                167.4179229736328,
                -1.2219537496566772
            ],
            [
                101.96917724609375,
                167.76092529296875,
                -1.8423174619674683
            ],
            [
                111.68753814697266,
                148.97178649902344,
                -14.380467414855957
            ],
            [
                103.0930404663086,
                147.16693115234375,
                -8.347593307495117
            ],
            [
                110.75141143798828,
                147.71250915527344,
                -14.535599708557129
            ],
            [
                96.64940643310547,
                126.8069076538086,
                -3.0794074535369873
            ],
            [
                88.27867889404297,
                130.69798278808594,
                -1.1869419813156128
            ],
            [
                100.04795837402344,
                140.60447692871094,
                -11.090539932250977
            ],
            [
                73.77545166015625,
                69.5117416381836,
                7.792771816253662
            ],
            [
                77.43281555175781,
                77.97010803222656,
                -0.2639492452144623
            ],
            [
                81.13420867919922,
                87.73043060302734,
                -6.5636701583862305
            ],
            [
                99.89777374267578,
                176.31246948242188,
                -0.4909457564353943
            ],
            [
                104.74893188476562,
                89.6520004272461,
                -15.053000450134277
            ],
            [
                102.84745788574219,
                75.23707580566406,
                -12.567231178283691
            ],
            [
                100.63813018798828,
                61.609283447265625,
                -9.285161972045898
            ],
            [
                80.65483093261719,
                113.52461242675781,
                5.074185848236084
            ],
            [
                68.86351013183594,
                119.2115478515625,
                14.128241539001465
            ],
            [
                102.50297546386719,
                111.3539810180664,
                1.951482892036438
            ],
            [
                73.61868286132812,
                104.9415283203125,
                7.281842231750488
            ],
            [
                105.75453186035156,
                119.77765655517578,
                -7.745715141296387
            ],
            [
                104.45488739013672,
                139.4197998046875,
                -22.29972267150879
            ],
            [
                63.716285705566406,
                122.96428680419922,
                20.95701026916504
            ],
            [
                72.44051361083984,
                123.27689361572266,
                8.991997718811035
            ],
            [
                79.17036437988281,
                125.41738891601562,
                3.621450185775757
            ],
            [
                89.11593627929688,
                124.43283081054688,
                0.8515294194221497
            ],
            [
                96.3904800415039,
                121.96058654785156,
                -0.5027655363082886
            ],
            [
                101.8059310913086,
                119.2264175415039,
                -2.2888076305389404
            ],
            [
                112.86542510986328,
                112.4175033569336,
                -14.591021537780762
            ],
            [
                64.75704956054688,
                134.9148406982422,
                20.005657196044922
            ],
            [
                69.34245300292969,
                104.0033950805664,
                9.942222595214844
            ],
            [
                115.83888244628906,
                146.15145874023438,
                -27.970314025878906
            ],
            [
                102.56527709960938,
                129.16445922851562,
                -7.453750133514404
            ],
            [
                59.023258209228516,
                111.31049346923828,
                56.982357025146484
            ],
            [
                105.87271118164062,
                116.21245574951172,
                -3.3605034351348877
            ],
            [
                99.69976043701172,
                140.8537139892578,
                -4.981838703155518
            ],
            [
                76.46947479248047,
                108.51949310302734,
                9.441862106323242
            ],
            [
                104.16857147216797,
                135.59938049316406,
                -20.17717742919922
            ],
            [
                62.55781936645508,
                149.81204223632812,
                61.52238845825195
            ],
            [
                102.33599853515625,
                109.21724700927734,
                3.352165937423706
            ],
            [
                108.66632080078125,
                132.43441772460938,
                -26.20445442199707
            ],
            [
                76.93183135986328,
                178.20008850097656,
                25.06099510192871
            ],
            [
                77.55424499511719,
                184.1396484375,
                36.33062744140625
            ],
            [
                60.514400482177734,
                135.87619018554688,
                41.55708694458008
            ],
            [
                70.61214447021484,
                170.30010986328125,
                32.29217529296875
            ],
            [
                62.31252670288086,
                100.87405395507812,
                30.00312042236328
            ],
            [
                98.29547119140625,
                197.71826171875,
                7.207530498504639
            ],
            [
                116.37822723388672,
                147.16690063476562,
                -19.846384048461914
            ],
            [
                97.96163940429688,
                133.36378479003906,
                -5.005223274230957
            ],
            [
                64.23298645019531,
                112.30160522460938,
                22.31523323059082
            ],
            [
                85.22616577148438,
                111.08460998535156,
                2.9976553916931152
            ],
            [
                89.86323547363281,
                111.52545166015625,
                1.5670009851455688
            ],
            [
                99.40528869628906,
                169.67178344726562,
                -0.6582879424095154
            ],
            [
                65.99947357177734,
                146.19723510742188,
                22.738571166992188
            ],
            [
                108.11463928222656,
                205.74154663085938,
                9.442840576171875
            ],
            [
                92.10523223876953,
                197.54750061035156,
                20.864992141723633
            ],
            [
                85.30396270751953,
                192.0162353515625,
                27.581401824951172
            ],
            [
                117.72201538085938,
                75.37532043457031,
                -13.732177734375
            ],
            [
                119.3282699584961,
                206.77301025390625,
                7.82768440246582
            ],
            [
                94.34012603759766,
                111.1155776977539,
                1.3127632141113281
            ],
            [
                98.52073669433594,
                110.21660614013672,
                2.090876579284668
            ],
            [
                101.12181091308594,
                109.71762084960938,
                3.2671499252319336
            ],
            [
                65.83094787597656,
                102.6583251953125,
                15.952875137329102
            ],
            [
                97.70925903320312,
                105.57070922851562,
                0.8912844657897949
            ],
            [
                93.11748504638672,
                104.27945709228516,
                -0.30966195464134216
            ],
            [
                88.4730453491211,
                104.05552673339844,
                -0.07610031962394714
            ],
            [
                83.86275482177734,
                104.92096710205078,
                1.414997935295105
            ],
            [
                80.99098205566406,
                106.25946807861328,
                3.4739134311676025
            ],
            [
                59.555267333984375,
                98.08499908447266,
                46.31218338012695
            ],
            [
                82.063720703125,
                110.23699951171875,
                4.874054908752441
            ],
            [
                118.69963836669922,
                153.22027587890625,
                -14.42333984375
            ],
            [
                101.1960220336914,
                155.33485412597656,
                -8.648452758789062
            ],
            [
                104.98086547851562,
                143.57220458984375,
                -16.18877601623535
            ],
            [
                111.35551452636719,
                153.67498779296875,
                -13.966086387634277
            ],
            [
                117.91822814941406,
                104.27511596679688,
                -13.102889060974121
            ],
            [
                83.9109115600586,
                185.85150146484375,
                19.43720054626465
            ],
            [
                90.80017852783203,
                191.86256408691406,
                13.639209747314453
            ],
            [
                107.79782104492188,
                201.759033203125,
                1.589878797531128
            ],
            [
                71.56157684326172,
                175.39718627929688,
                47.04523849487305
            ],
            [
                100.90824890136719,
                107.65621185302734,
                2.283372402191162
            ],
            [
                109.40359497070312,
                121.5020980834961,
                -15.84511947631836
            ],
            [
                119.35195922851562,
                202.79319763183594,
                0.29308897256851196
            ],
            [
                99.45650482177734,
                202.36302185058594,
                13.852992057800293
            ],
            [
                62.44034194946289,
                148.21847534179688,
                41.524314880371094
            ],
            [
                109.30650329589844,
                167.2877960205078,
                -6.6295881271362305
            ],
            [
                108.57228088378906,
                168.67799377441406,
                -7.716444492340088
            ],
            [
                107.81466674804688,
                170.94361877441406,
                -8.65229606628418
            ],
            [
                107.1982192993164,
                174.04676818847656,
                -7.856087684631348
            ],
            [
                105.46961212158203,
                179.48504638671875,
                -3.189915180206299
            ],
            [
                101.80140686035156,
                167.8551025390625,
                -1.972059965133667
            ],
            [
                100.18743896484375,
                167.49827575683594,
                -2.0849380493164062
            ],
            [
                98.61748504638672,
                166.70556640625,
                -2.133786678314209
            ],
            [
                93.11396789550781,
                163.00418090820312,
                -1.1458740234375
            ],
            [
                72.74813842773438,
                149.35427856445312,
                10.758158683776855
            ],
            [
                109.389892578125,
                115.7384033203125,
                -10.734211921691895
            ],
            [
                106.5068588256836,
                105.60597229003906,
                -1.216935396194458
            ],
            [
                103.1895980834961,
                106.46931457519531,
                1.0187095403671265
            ],
            [
                102.95471954345703,
                167.16014099121094,
                -1.3776367902755737
            ],
            [
                72.48131561279297,
                162.68414306640625,
                20.442808151245117
            ],
            [
                111.07872772216797,
                105.31053924560547,
                -8.91411018371582
            ],
            [
                102.2643051147461,
                185.5220947265625,
                0.3753073811531067
            ],
            [
                118.21818542480469,
                123.35292053222656,
                -26.551424026489258
            ],
            [
                113.1424560546875,
                118.5971908569336,
                -20.16622543334961
            ],
            [
                118.11599731445312,
                117.31977844238281,
                -21.563594818115234
            ],
            [
                105.6987533569336,
                130.5016326904297,
                -15.171625137329102
            ],
            [
                119.33872985839844,
                196.61549377441406,
                -3.4977939128875732
            ],
            [
                119.24801635742188,
                188.91934204101562,
                -3.897473096847534
            ],
            [
                110.55528259277344,
                188.51718139648438,
                -2.806584596633911
            ],
            [
                90.01423645019531,
                175.39718627929688,
                6.012148380279541
            ],
            [
                95.58554077148438,
                145.37600708007812,
                -3.5377821922302246
            ],
            [
                95.62660217285156,
                181.22352600097656,
                3.4219298362731934
            ],
            [
                83.78854370117188,
                144.54547119140625,
                -0.9838578104972839
            ],
            [
                91.07451629638672,
                151.07794189453125,
                -2.3644163608551025
            ],
            [
                79.59300231933594,
                153.67205810546875,
                4.215156555175781
            ],
            [
                108.64999389648438,
                195.7953338623047,
                -1.9781476259231567
            ],
            [
                102.55193328857422,
                133.64300537109375,
                -10.71445083618164
            ],
            [
                85.4017105102539,
                179.68325805664062,
                12.082082748413086
            ],
            [
                92.40608215332031,
                186.09906005859375,
                8.489044189453125
            ],
            [
                85.635498046875,
                168.60435485839844,
                6.409209728240967
            ],
            [
                67.59174346923828,
                155.719970703125,
                25.44757652282715
            ],
            [
                79.05279541015625,
                169.14212036132812,
                12.592918395996094
            ],
            [
                65.3196029663086,
                159.64808654785156,
                39.700767517089844
            ],
            [
                87.28292846679688,
                158.58056640625,
                0.7172022461891174
            ],
            [
                106.01924133300781,
                125.2275390625,
                -11.32587718963623
            ],
            [
                106.27057647705078,
                141.9310302734375,
                -23.54264259338379
            ],
            [
                102.78170013427734,
                143.1742401123047,
                -16.909927368164062
            ],
            [
                108.57403564453125,
                138.33213806152344,
                -28.041946411132812
            ],
            [
                102.22100067138672,
                101.56929016113281,
                -3.4346392154693604
            ],
            [
                93.53273010253906,
                98.99156951904297,
                -4.834954738616943
            ],
            [
                86.07599639892578,
                98.4598388671875,
                -4.4784393310546875
            ],
            [
                79.93020629882812,
                99.06939697265625,
                -1.9790793657302856
            ],
            [
                75.64928436279297,
                101.09931945800781,
                1.9282158613204956
            ],
            [
                72.9649658203125,
                109.90436553955078,
                11.854694366455078
            ],
            [
                59.47199249267578,
                123.84939575195312,
                39.506927490234375
            ],
            [
                77.0810317993164,
                117.59391021728516,
                7.667500972747803
            ],
            [
                82.46488952636719,
                119.22377014160156,
                4.087185859680176
            ],
            [
                89.41935729980469,
                119.13565826416016,
                1.6742497682571411
            ],
            [
                96.0038833618164,
                117.74301147460938,
                0.673589825630188
            ],
            [
                101.08658599853516,
                115.84601593017578,
                0.2831626534461975
            ],
            [
                104.59732055664062,
                113.9703140258789,
                -0.14186634123325348
            ],
            [
                59.842071533203125,
                123.75599670410156,
                62.147132873535156
            ],
            [
                103.01998901367188,
                144.56573486328125,
                -13.852197647094727
            ],
            [
                109.43720245361328,
                126.78997802734375,
                -20.17110252380371
            ],
            [
                110.17687225341797,
                142.37425231933594,
                -28.159927368164062
            ],
            [
                113.19120025634766,
                145.03236389160156,
                -25.576139450073242
            ],
            [
                110.1976089477539,
                143.11456298828125,
                -25.221750259399414
            ],
            [
                104.65864562988281,
                146.29872131347656,
                -11.73967170715332
            ],
            [
                114.16331481933594,
                145.66648864746094,
                -27.14698600769043
            ],
            [
                114.66024017333984,
                146.71180725097656,
                -19.931026458740234
            ],
            [
                104.24486541748047,
                109.6845474243164,
                2.4417476654052734
            ],
            [
                107.33145141601562,
                110.96194458007812,
                -1.1111698150634766
            ],
            [
                108.96925354003906,
                111.89136505126953,
                -5.281299114227295
            ],
            [
                79.3460693359375,
                107.23329162597656,
                5.60056209564209
            ],
            [
                76.67984008789062,
                105.5783920288086,
                5.686931610107422
            ],
            [
                122.84153747558594,
                124.22296905517578,
                -24.344675064086914
            ],
            [
                155.95977783203125,
                109.22726440429688,
                7.334073066711426
            ],
            [
                123.54529571533203,
                145.69973754882812,
                -19.964433670043945
            ],
            [
                173.38943481445312,
                87.13379669189453,
                34.3399772644043
            ],
            [
                140.69699096679688,
                114.11424255371094,
                1.2109861373901367
            ],
            [
                145.976318359375,
                114.58908081054688,
                1.6804367303848267
            ],
            [
                151.01254272460938,
                114.33756256103516,
                3.355182409286499
            ],
            [
                157.6327667236328,
                111.36378479003906,
                8.357008934020996
            ],
            [
                136.27047729492188,
                112.68612670898438,
                1.6222927570343018
            ],
            [
                148.0469512939453,
                101.52294158935547,
                -1.762386679649353
            ],
            [
                142.4116668701172,
                101.71417999267578,
                -1.8313332796096802
            ],
            [
                153.13783264160156,
                102.22638702392578,
                0.3153851628303528
            ],
            [
                156.50238037109375,
                103.79371643066406,
                2.9880430698394775
            ],
            [
                161.62667846679688,
                114.84622955322266,
                11.560099601745605
            ],
            [
                138.81057739257812,
                191.45655822753906,
                3.607323408126831
            ],
            [
                157.78128051757812,
                107.9542007446289,
                9.194131851196289
            ],
            [
                175.50888061523438,
                111.5647201538086,
                38.25723648071289
            ],
            [
                167.32241821289062,
                111.04369354248047,
                17.4151554107666
            ],
            [
                144.905517578125,
                137.5779266357422,
                -3.1244139671325684
            ],
            [
                125.5378189086914,
                161.4170684814453,
                -14.684042930603027
            ],
            [
                124.62126159667969,
                167.13519287109375,
                -11.481496810913086
            ],
            [
                132.2530975341797,
                162.86099243164062,
                -11.07283878326416
            ],
            [
                136.4534912109375,
                164.8792266845703,
                -6.6808929443359375
            ],
            [
                129.4559783935547,
                167.1495819091797,
                -9.141393661499023
            ],
            [
                133.21205139160156,
                167.45494079589844,
                -5.1382832527160645
            ],
            [
                142.86898803710938,
                172.51820373535156,
                2.7330069541931152
            ],
            [
                123.00823211669922,
                143.35919189453125,
                -30.886960983276367
            ],
            [
                123.68092346191406,
                137.74510192871094,
                -32.99831771850586
            ],
            [
                164.63258361816406,
                97.86701965332031,
                4.355432033538818
            ],
            [
                134.2384796142578,
                123.31838989257812,
                -5.022059440612793
            ],
            [
                135.71119689941406,
                141.03334045410156,
                -15.905627250671387
            ],
            [
                135.91885375976562,
                137.9034881591797,
                -14.223589897155762
            ],
            [
                160.1938018798828,
                136.79183959960938,
                4.717921733856201
            ],
            [
                123.26856231689453,
                130.4422607421875,
                -29.777019500732422
            ],
            [
                152.53158569335938,
                92.80870819091797,
                -6.7318196296691895
            ],
            [
                159.76461791992188,
                94.31718444824219,
                -1.8263874053955078
            ],
            [
                168.96148681640625,
                77.21971893310547,
                21.765567779541016
            ],
            [
                129.21762084960938,
                97.3161849975586,
                -11.966418266296387
            ],
            [
                137.42381286621094,
                103.12054443359375,
                0.04886084049940109
            ],
            [
                146.907470703125,
                167.5518035888672,
                4.118580341339111
            ],
            [
                170.12811279296875,
                163.3605194091797,
                57.68179702758789
            ],
            [
                131.80506896972656,
                144.19598388671875,
                -13.513188362121582
            ],
            [
                127.26636505126953,
                146.16580200195312,
                -14.188481330871582
            ],
            [
                141.09048461914062,
                167.7042999267578,
                3.3114333152770996
            ],
            [
                138.66995239257812,
                167.3173065185547,
                1.582306146621704
            ],
            [
                162.63259887695312,
                90.31060791015625,
                0.986547589302063
            ],
            [
                135.81442260742188,
                143.40643310546875,
                -12.51405143737793
            ],
            [
                142.52125549316406,
                93.40934753417969,
                -10.279659271240234
            ],
            [
                143.57244873046875,
                88.45161437988281,
                -11.77291488647461
            ],
            [
                148.54998779296875,
                64.06002807617188,
                -2.4149906635284424
            ],
            [
                165.6756591796875,
                83.40154266357422,
                9.850789070129395
            ],
            [
                145.50039672851562,
                75.64704895019531,
                -7.541848182678223
            ],
            [
                167.5852508544922,
                95.07487487792969,
                9.425344467163086
            ],
            [
                170.452880859375,
                91.3118896484375,
                21.05847930908203
            ],
            [
                125.20304107666016,
                164.79669189453125,
                -13.785435676574707
            ],
            [
                130.6887664794922,
                165.54884338378906,
                -10.394638061523438
            ],
            [
                134.81166076660156,
                166.30975341796875,
                -6.418834209442139
            ],
            [
                130.409912109375,
                145.23471069335938,
                -12.378215789794922
            ],
            [
                139.83499145507812,
                167.59437561035156,
                2.3482885360717773
            ],
            [
                137.60861206054688,
                168.17816162109375,
                -1.4060178995132446
            ],
            [
                138.13058471679688,
                166.99790954589844,
                1.3653502464294434
            ],
            [
                128.9259796142578,
                142.63140869140625,
                -22.044574737548828
            ],
            [
                132.10987854003906,
                167.0681610107422,
                -4.17445182800293
            ],
            [
                128.32369995117188,
                167.34730529785156,
                -6.739085674285889
            ],
            [
                123.9146499633789,
                167.74928283691406,
                -8.868383407592773
            ],
            [
                125.95021057128906,
                181.73095703125,
                -4.20366096496582
            ],
            [
                125.53544616699219,
                175.65975952148438,
                -10.020724296569824
            ],
            [
                125.1830825805664,
                172.26112365722656,
                -10.736661911010742
            ],
            [
                124.74713134765625,
                169.3335723876953,
                -9.376955032348633
            ],
            [
                124.27887725830078,
                167.40823364257812,
                -8.436172485351562
            ],
            [
                132.81260681152344,
                167.0230255126953,
                -3.921337842941284
            ],
            [
                133.6058349609375,
                167.7140655517578,
                -4.9160075187683105
            ],
            [
                134.77474975585938,
                169.24192810058594,
                -5.689537048339844
            ],
            [
                135.8251495361328,
                171.2283477783203,
                -4.585168361663818
            ],
            [
                140.90988159179688,
                158.22494506835938,
                -5.029215335845947
            ],
            [
                175.01495361328125,
                135.75442504882812,
                64.78570556640625
            ],
            [
                135.3119354248047,
                167.0819549560547,
                -0.8971143960952759
            ],
            [
                136.33798217773438,
                167.40139770507812,
                -1.508284330368042
            ],
            [
                125.42987060546875,
                148.87193298339844,
                -14.274346351623535
            ],
            [
                133.92514038085938,
                146.8848419189453,
                -8.02297592163086
            ],
            [
                126.30365753173828,
                147.5902557373047,
                -14.421208381652832
            ],
            [
                139.7086944580078,
                126.5849380493164,
                -2.6084320545196533
            ],
            [
                148.19424438476562,
                130.37986755371094,
                -0.5620904564857483
            ],
            [
                136.7407684326172,
                140.3019256591797,
                -10.690805435180664
            ],
            [
                161.197265625,
                69.34352111816406,
                8.728507041931152
            ],
            [
                157.7979278564453,
                77.91861724853516,
                0.6010512709617615
            ],
            [
                154.4151611328125,
                87.81568908691406,
                -5.846424579620361
            ],
            [
                138.3963165283203,
                176.0116424560547,
                -0.1538432538509369
            ],
            [
                130.9725341796875,
                89.73095703125,
                -14.795687675476074
            ],
            [
                132.5423583984375,
                75.20111083984375,
                -12.23374080657959
            ],
            [
                134.42320251464844,
                61.57011032104492,
                -8.980547904968262
            ],
            [
                155.27586364746094,
                113.33280944824219,
                5.952434539794922
            ],
            [
                167.0068359375,
                118.77996826171875,
                15.234307289123535
            ],
            [
                133.5114288330078,
                111.29006958007812,
                2.3601605892181396
            ],
            [
                162.06199645996094,
                104.83332061767578,
                8.25685977935791
            ],
            [
                130.4895782470703,
                119.69023895263672,
                -7.450784206390381
            ],
            [
                132.3848419189453,
                139.24404907226562,
                -21.97791290283203
            ],
            [
                172.18206787109375,
                122.43741607666016,
                22.228647232055664
            ],
            [
                163.63775634765625,
                122.85443878173828,
                10.01909351348877
            ],
            [
                157.08656311035156,
                125.0364990234375,
                4.479675769805908
            ],
            [
                147.17445373535156,
                124.16161346435547,
                1.5277549028396606
            ],
            [
                139.84307861328125,
                121.77812194824219,
                0.0027251075953245163
            ],
            [
                134.36807250976562,
                119.108154296875,
                -1.9097141027450562
            ],
            [
                123.22822570800781,
                112.37742614746094,
                -14.463367462158203
            ],
            [
                171.46395874023438,
                134.3226318359375,
                21.277406692504883
            ],
            [
                166.27719116210938,
                103.80069732666016,
                11.055558204650879
            ],
            [
                121.24270629882812,
                146.1110076904297,
                -27.890941619873047
            ],
            [
                133.88482666015625,
                128.99838256835938,
                -7.111136436462402
            ],
            [
                176.16445922851562,
                110.81060791015625,
                58.399478912353516
            ],
            [
                130.26846313476562,
                116.13423156738281,
                -3.0669960975646973
            ],
            [
                137.05477905273438,
                140.53163146972656,
                -4.6022772789001465
            ],
            [
                159.28594970703125,
                108.41778564453125,
                10.382974624633789
            ],
            [
                132.53890991210938,
                135.4156036376953,
                -19.858644485473633
            ],
            [
                173.49998474121094,
                149.25376892089844,
                62.86159896850586
            ],
            [
                133.61578369140625,
                109.1581039428711,
                3.78249192237854
            ],
            [
                128.00729370117188,
                132.34567260742188,
                -25.971696853637695
            ],
            [
                160.63453674316406,
                177.72833251953125,
                25.987520217895508
            ],
            [
                159.90013122558594,
                183.69088745117188,
                37.32156753540039
            ],
            [
                175.46409606933594,
                135.31329345703125,
                42.94356155395508
            ],
            [
                166.5187530517578,
                169.7675323486328,
                33.36517333984375
            ],
            [
                173.0380859375,
                100.53102111816406,
                31.325349807739258
            ],
            [
                140.0427703857422,
                197.4462432861328,
                7.603298187255859
            ],
            [
                120.66442108154297,
                147.15390014648438,
                -19.77289390563965
            ],
            [
                138.5693817138672,
                133.11203002929688,
                -4.5740065574646
            ],
            [
                171.39910888671875,
                111.9096450805664,
                23.570072174072266
            ],
            [
                150.7473907470703,
                110.93775939941406,
                3.7676494121551514
            ],
            [
                146.12115478515625,
                111.42359161376953,
                2.2459464073181152
            ],
            [
                138.94503784179688,
                169.30123901367188,
                -0.2979637086391449
            ],
            [
                170.4958038330078,
                145.58143615722656,
                23.911178588867188
            ],
            [
                130.43089294433594,
                205.58187866210938,
                9.644326210021973
            ],
            [
                146.002197265625,
                197.22303771972656,
                21.40969467163086
            ],
            [
                152.5524444580078,
                191.64596557617188,
                28.352481842041016
            ],
            [
                141.6517791748047,
                111.0348892211914,
                1.867456316947937
            ],
            [
                137.45309448242188,
                110.12110900878906,
                2.602623462677002
            ],
            [
                134.82908630371094,
                109.65119934082031,
                3.724750280380249
            ],
            [
                169.7152862548828,
                102.39374542236328,
                17.10785484313965
            ],
            [
                138.20118713378906,
                105.53400421142578,
                1.3848233222961426
            ],
            [
                142.81710815429688,
                104.25692749023438,
                0.2953520715236664
            ],
            [
                147.45089721679688,
                104.04034423828125,
                0.5978397727012634
            ],
            [
                152.0496368408203,
                104.87964630126953,
                2.195375442504883
            ],
            [
                154.88734436035156,
                106.20946502685547,
                4.306293487548828
            ],
            [
                175.49468994140625,
                97.66238403320312,
                47.681251525878906
            ],
            [
                153.84779357910156,
                110.1096420288086,
                5.69104528427124
            ],
            [
                136.30126953125,
                154.99261474609375,
                -8.315324783325195
            ],
            [
                131.94606018066406,
                143.37841796875,
                -15.895578384399414
            ],
            [
                126.12041473388672,
                153.559326171875,
                -13.83856201171875
            ],
            [
                153.9490966796875,
                185.45046997070312,
                20.150609970092773
            ],
            [
                147.3176727294922,
                191.5094757080078,
                14.23727035522461
            ],
            [
                130.77731323242188,
                201.58995056152344,
                1.7847367525100708
            ],
            [
                165.39755249023438,
                174.8896942138672,
                48.15724563598633
            ],
            [
                135.01080322265625,
                107.61424255371094,
                2.7306060791015625
            ],
            [
                126.94625854492188,
                121.43367004394531,
                -15.613755226135254
            ],
            [
                138.8760528564453,
                202.1226806640625,
                14.306870460510254
            ],
            [
                173.8612823486328,
                147.64385986328125,
                42.82856750488281
            ],
            [
                128.93740844726562,
                167.129150390625,
                -6.409834861755371
            ],
            [
                129.71951293945312,
                168.48553466796875,
                -7.506717205047607
            ],
            [
                130.52171325683594,
                170.75640869140625,
                -8.487283706665039
            ],
            [
                131.2073974609375,
                173.84405517578125,
                -7.658293724060059
            ],
            [
                132.88243103027344,
                179.26658630371094,
                -2.9844183921813965
            ],
            [
                136.49769592285156,
                167.48562622070312,
                -1.6502294540405273
            ],
            [
                138.09669494628906,
                167.10549926757812,
                -1.678907871246338
            ],
            [
                139.63938903808594,
                166.27142333984375,
                -1.6933009624481201
            ],
            [
                144.85403442382812,
                162.55697631835938,
                -0.6240276098251343
            ],
            [
                164.09494018554688,
                148.80545043945312,
                11.702927589416504
            ],
            [
                126.76860809326172,
                115.6725845336914,
                -10.533944129943848
            ],
            [
                129.3566131591797,
                105.59530639648438,
                -0.9609823226928711
            ],
            [
                132.69496154785156,
                106.45590209960938,
                1.4397248029708862
            ],
            [
                135.2975311279297,
                166.78652954101562,
                -1.023319959640503
            ],
            [
                164.6529083251953,
                162.1170196533203,
                21.44499397277832
            ],
            [
                124.80030059814453,
                105.3028335571289,
                -8.767714500427246
            ],
            [
                136.01727294921875,
                185.2764434814453,
                0.6569437384605408
            ],
            [
                123.13665771484375,
                118.54371643066406,
                -20.06808090209961
            ],
            [
                130.81472778320312,
                130.37637329101562,
                -14.867352485656738
            ],
            [
                127.8617935180664,
                188.3887939453125,
                -2.6835858821868896
            ],
            [
                148.0277557373047,
                174.9688720703125,
                6.548011302947998
            ],
            [
                141.39398193359375,
                145.0400848388672,
                -3.0821075439453125
            ],
            [
                142.53695678710938,
                180.87489318847656,
                3.8108036518096924
            ],
            [
                153.1754608154297,
                144.14674377441406,
                -0.3275127112865448
            ],
            [
                146.2545928955078,
                150.6615753173828,
                -1.8075451850891113
            ],
            [
                157.58824157714844,
                153.1927032470703,
                4.934145927429199
            ],
            [
                129.8577423095703,
                195.66049194335938,
                -1.784031867980957
            ],
            [
                134.0182342529297,
                133.43296813964844,
                -10.349359512329102
            ],
            [
                152.49838256835938,
                179.24888610839844,
                12.764558792114258
            ],
            [
                145.72158813476562,
                185.7590789794922,
                8.999100685119629
            ],
            [
                152.22340393066406,
                168.12855529785156,
                7.078319072723389
            ],
            [
                169.18080139160156,
                155.10922241210938,
                26.575763702392578
            ],
            [
                158.51528930664062,
                168.64369201660156,
                13.39535140991211
            ],
            [
                171.34249877929688,
                159.0767822265625,
                40.92788314819336
            ],
            [
                150.37347412109375,
                158.1188507080078,
                1.3170418739318848
            ],
            [
                130.36158752441406,
                125.12071990966797,
                -11.025984764099121
            ],
            [
                130.65074157714844,
                141.73614501953125,
                -23.25238609313965
            ],
            [
                134.1525115966797,
                142.92623901367188,
                -16.600086212158203
            ],
            [
                128.29025268554688,
                138.22067260742188,
                -27.823015213012695
            ],
            [
                133.6039581298828,
                101.5875244140625,
                -3.07625675201416
            ],
            [
                142.2752227783203,
                99.06980895996094,
                -4.309804439544678
            ],
            [
                149.6817169189453,
                98.49995422363281,
                -3.7846388816833496
            ],
            [
                155.8155975341797,
                99.07466125488281,
                -1.116007685661316
            ],
            [
                160.0244598388672,
                101.05924224853516,
                2.857253074645996
            ],
            [
                162.7498321533203,
                109.69417572021484,
                12.883472442626953
            ],
            [
                176.1880645751953,
                123.33212280273438,
                40.90973663330078
            ],
            [
                158.8791046142578,
                117.33142852783203,
                8.646967887878418
            ],
            [
                153.6244354248047,
                118.95820617675781,
                4.919290542602539
            ],
            [
                146.71292114257812,
                118.95172119140625,
                2.355144739151001
            ],
            [
                140.10670471191406,
                117.60516357421875,
                1.1949496269226074
            ],
            [
                134.98941040039062,
                115.74888610839844,
                0.6643215417861938
            ],
            [
                131.4561767578125,
                113.90116119384766,
                0.16929467022418976
            ],
            [
                175.5679473876953,
                123.2087173461914,
                63.57815933227539
            ],
            [
                133.9481964111328,
                144.31849670410156,
                -13.537425994873047
            ],
            [
                127.04625701904297,
                126.72212219238281,
                -19.901891708374023
            ],
            [
                126.8248519897461,
                142.29302978515625,
                -27.979829788208008
            ],
            [
                123.83879089355469,
                144.9559326171875,
                -25.450485229492188
            ],
            [
                126.77915954589844,
                143.03590393066406,
                -25.02594757080078
            ],
            [
                132.365478515625,
                146.0387725830078,
                -11.47732925415039
            ],
            [
                122.90725708007812,
                145.61497497558594,
                -27.055374145507812
            ],
            [
                122.36988830566406,
                146.66429138183594,
                -19.87354278564453
            ],
            [
                131.71080017089844,
                109.6417465209961,
                2.8075015544891357
            ],
            [
                128.65235900878906,
                110.94033813476562,
                -0.8218579292297363
            ],
            [
                127.07047271728516,
                111.85054016113281,
                -5.076536178588867
            ],
            [
                156.50816345214844,
                107.17440795898438,
                6.463142395019531
            ],
            [
                159.0517120361328,
                105.50051879882812,
                6.624624252319336
            ]
        ],
        "annotations": {
            "silhouette": [
                [
                    117.53205108642578,
                    61.06400680541992,
                    -10.692856788635254
                ],
                [
                    134.42320251464844,
                    61.57011032104492,
                    -8.980547904968262
                ],
                [
                    148.54998779296875,
                    64.06002807617188,
                    -2.4149906635284424
                ],
                [
                    161.197265625,
                    69.34352111816406,
                    8.728507041931152
                ],
                [
                    168.96148681640625,
                    77.21971893310547,
                    21.765567779541016
                ],
                [
                    173.38943481445312,
                    87.13379669189453,
                    34.3399772644043
                ],
                [
                    175.49468994140625,
                    97.66238403320312,
                    47.681251525878906
                ],
                [
                    176.16445922851562,
                    110.81060791015625,
                    58.399478912353516
                ],
                [
                    175.5679473876953,
                    123.2087173461914,
                    63.57815933227539
                ],
                [
                    175.01495361328125,
                    135.75442504882812,
                    64.78570556640625
                ],
                [
                    173.49998474121094,
                    149.25376892089844,
                    62.86159896850586
                ],
                [
                    170.12811279296875,
                    163.3605194091797,
                    57.68179702758789
                ],
                [
                    165.39755249023438,
                    174.8896942138672,
                    48.15724563598633
                ],
                [
                    159.90013122558594,
                    183.69088745117188,
                    37.32156753540039
                ],
                [
                    152.5524444580078,
                    191.64596557617188,
                    28.352481842041016
                ],
                [
                    146.002197265625,
                    197.22303771972656,
                    21.40969467163086
                ],
                [
                    138.8760528564453,
                    202.1226806640625,
                    14.306870460510254
                ],
                [
                    130.43089294433594,
                    205.58187866210938,
                    9.644326210021973
                ],
                [
                    119.3282699584961,
                    206.77301025390625,
                    7.82768440246582
                ],
                [
                    108.11463928222656,
                    205.74154663085938,
                    9.442840576171875
                ],
                [
                    99.45650482177734,
                    202.36302185058594,
                    13.852992057800293
                ],
                [
                    92.10523223876953,
                    197.54750061035156,
                    20.864992141723633
                ],
                [
                    85.30396270751953,
                    192.0162353515625,
                    27.581401824951172
                ],
                [
                    77.55424499511719,
                    184.1396484375,
                    36.33062744140625
                ],
                [
                    71.56157684326172,
                    175.39718627929688,
                    47.04523849487305
                ],
                [
                    66.36627960205078,
                    163.955322265625,
                    56.44671630859375
                ],
                [
                    62.55781936645508,
                    149.81204223632812,
                    61.52238845825195
                ],
                [
                    60.65744400024414,
                    136.31793212890625,
                    63.382606506347656
                ],
                [
                    59.842071533203125,
                    123.75599670410156,
                    62.147132873535156
                ],
                [
                    59.023258209228516,
                    111.31049346923828,
                    56.982357025146484
                ],
                [
                    59.555267333984375,
                    98.08499908447266,
                    46.31218338012695
                ],
                [
                    61.66621398925781,
                    87.46815490722656,
                    32.993343353271484
                ],
                [
                    66.03646850585938,
                    77.49429321289062,
                    20.62157440185547
                ],
                [
                    73.77545166015625,
                    69.5117416381836,
                    7.792771816253662
                ],
                [
                    86.4853744506836,
                    64.16480255126953,
                    -3.0586788654327393
                ],
                [
                    100.63813018798828,
                    61.609283447265625,
                    -9.285161972045898
                ]
            ],
            "lipsUpperOuter": [
                [
                    97.18721771240234,
                    168.13119506835938,
                    2.833859443664551
                ],
                [
                    98.61748504638672,
                    166.70556640625,
                    -2.133786678314209
                ],
                [
                    101.7018051147461,
                    165.21115112304688,
                    -7.061762809753418
                ],
                [
                    105.77255249023438,
                    163.10311889648438,
                    -11.334951400756836
                ],
                [
                    112.4089584350586,
                    161.5481414794922,
                    -14.824533462524414
                ],
                [
                    118.98641204833984,
                    162.48776245117188,
                    -15.517449378967285
                ],
                [
                    125.5378189086914,
                    161.4170684814453,
                    -14.684042930603027
                ],
                [
                    132.2530975341797,
                    162.86099243164062,
                    -11.07283878326416
                ],
                [
                    136.4534912109375,
                    164.8792266845703,
                    -6.6808929443359375
                ],
                [
                    139.63938903808594,
                    166.27142333984375,
                    -1.6933009624481201
                ],
                [
                    141.09048461914062,
                    167.7042999267578,
                    3.3114333152770996
                ]
            ],
            "lipsLowerOuter": [
                [
                    99.40528869628906,
                    169.67178344726562,
                    -0.6582879424095154
                ],
                [
                    102.55007934570312,
                    171.52511596679688,
                    -4.8553571701049805
                ],
                [
                    107.1982192993164,
                    174.04676818847656,
                    -7.856087684631348
                ],
                [
                    112.90489196777344,
                    175.74624633789062,
                    -10.10494613647461
                ],
                [
                    119.21676635742188,
                    176.16928100585938,
                    -10.431467056274414
                ],
                [
                    125.53544616699219,
                    175.65975952148438,
                    -10.020724296569824
                ],
                [
                    131.2073974609375,
                    173.84405517578125,
                    -7.658293724060059
                ],
                [
                    135.8251495361328,
                    171.2283477783203,
                    -4.585168361663818
                ],
                [
                    138.94503784179688,
                    169.30123901367188,
                    -0.2979637086391449
                ],
                [
                    141.09048461914062,
                    167.7042999267578,
                    3.3114333152770996
                ]
            ],
            "lipsUpperInner": [
                [
                    100.1477279663086,
                    167.40997314453125,
                    0.9858667850494385
                ],
                [
                    102.95471954345703,
                    167.16014099121094,
                    -1.3776367902755737
                ],
                [
                    106.09491729736328,
                    167.3335418701172,
                    -4.4183478355407715
                ],
                [
                    109.84033966064453,
                    167.54312133789062,
                    -6.930975914001465
                ],
                [
                    114.25239562988281,
                    167.82916259765625,
                    -8.986292839050293
                ],
                [
                    119.06120300292969,
                    168.0637969970703,
                    -9.63233757019043
                ],
                [
                    123.9146499633789,
                    167.74928283691406,
                    -8.868383407592773
                ],
                [
                    128.32369995117188,
                    167.34730529785156,
                    -6.739085674285889
                ],
                [
                    132.10987854003906,
                    167.0681610107422,
                    -4.17445182800293
                ],
                [
                    135.2975311279297,
                    166.78652954101562,
                    -1.023319959640503
                ],
                [
                    138.13058471679688,
                    166.99790954589844,
                    1.3653502464294434
                ]
            ],
            "lipsLowerInner": [
                [
                    100.1477279663086,
                    167.40997314453125,
                    0.9858667850494385
                ],
                [
                    102.9673843383789,
                    167.4179229736328,
                    -1.2219537496566772
                ],
                [
                    105.40119171142578,
                    167.2918243408203,
                    -4.173025131225586
                ],
                [
                    109.30650329589844,
                    167.2877960205078,
                    -6.6295881271362305
                ],
                [
                    113.95097351074219,
                    167.50331115722656,
                    -8.567123413085938
                ],
                [
                    119.11689758300781,
                    167.60427856445312,
                    -9.164018630981445
                ],
                [
                    124.27887725830078,
                    167.40823364257812,
                    -8.436172485351562
                ],
                [
                    128.93740844726562,
                    167.129150390625,
                    -6.409834861755371
                ],
                [
                    132.81260681152344,
                    167.0230255126953,
                    -3.921337842941284
                ],
                [
                    135.3119354248047,
                    167.0819549560547,
                    -0.8971143960952759
                ],
                [
                    138.13058471679688,
                    166.99790954589844,
                    1.3653502464294434
                ]
            ],
            "rightEyeUpper0": [
                [
                    79.3460693359375,
                    107.23329162597656,
                    5.60056209564209
                ],
                [
                    80.99098205566406,
                    106.25946807861328,
                    3.4739134311676025
                ],
                [
                    83.86275482177734,
                    104.92096710205078,
                    1.414997935295105
                ],
                [
                    88.4730453491211,
                    104.05552673339844,
                    -0.07610031962394714
                ],
                [
                    93.11748504638672,
                    104.27945709228516,
                    -0.30966195464134216
                ],
                [
                    97.70925903320312,
                    105.57070922851562,
                    0.8912844657897949
                ],
                [
                    100.90824890136719,
                    107.65621185302734,
                    2.283372402191162
                ]
            ],
            "rightEyeLower0": [
                [
                    78.05350494384766,
                    108.0526123046875,
                    8.296472549438477
                ],
                [
                    79.91556549072266,
                    109.36308288574219,
                    6.463442802429199
                ],
                [
                    82.063720703125,
                    110.23699951171875,
                    4.874054908752441
                ],
                [
                    85.22616577148438,
                    111.08460998535156,
                    2.9976553916931152
                ],
                [
                    89.86323547363281,
                    111.52545166015625,
                    1.5670009851455688
                ],
                [
                    94.34012603759766,
                    111.1155776977539,
                    1.3127632141113281
                ],
                [
                    98.52073669433594,
                    110.21660614013672,
                    2.090876579284668
                ],
                [
                    101.12181091308594,
                    109.71762084960938,
                    3.2671499252319336
                ],
                [
                    102.33599853515625,
                    109.21724700927734,
                    3.352165937423706
                ]
            ],
            "rightEyeUpper1": [
                [
                    76.67984008789062,
                    105.5783920288086,
                    5.686931610107422
                ],
                [
                    79.25779724121094,
                    103.8443832397461,
                    2.085986852645874
                ],
                [
                    82.66515350341797,
                    102.23857879638672,
                    -0.4704916477203369
                ],
                [
                    87.8006591796875,
                    101.4993667602539,
                    -2.45806622505188
                ],
                [
                    93.42230987548828,
                    101.69088745117188,
                    -2.3722519874572754
                ],
                [
                    98.4504165649414,
                    103.12554168701172,
                    -0.4041958451271057
                ],
                [
                    103.1895980834961,
                    106.46931457519531,
                    1.0187095403671265
                ]
            ],
            "rightEyeLower1": [
                [
                    76.46947479248047,
                    108.51949310302734,
                    9.441862106323242
                ],
                [
                    78.202392578125,
                    111.50921630859375,
                    7.432613849639893
                ],
                [
                    80.65483093261719,
                    113.52461242675781,
                    5.074185848236084
                ],
                [
                    84.99339294433594,
                    114.50077056884766,
                    2.5710299015045166
                ],
                [
                    90.06871795654297,
                    114.70950317382812,
                    0.9860450625419617
                ],
                [
                    95.33509063720703,
                    114.19541931152344,
                    0.6521462202072144
                ],
                [
                    99.73709869384766,
                    112.77399444580078,
                    1.1813251972198486
                ],
                [
                    102.50297546386719,
                    111.3539810180664,
                    1.951482892036438
                ],
                [
                    104.24486541748047,
                    109.6845474243164,
                    2.4417476654052734
                ]
            ],
            "rightEyeUpper2": [
                [
                    73.61868286132812,
                    104.9415283203125,
                    7.281842231750488
                ],
                [
                    75.64928436279297,
                    101.09931945800781,
                    1.9282158613204956
                ],
                [
                    79.93020629882812,
                    99.06939697265625,
                    -1.9790793657302856
                ],
                [
                    86.07599639892578,
                    98.4598388671875,
                    -4.4784393310546875
                ],
                [
                    93.53273010253906,
                    98.99156951904297,
                    -4.834954738616943
                ],
                [
                    102.22100067138672,
                    101.56929016113281,
                    -3.4346392154693604
                ],
                [
                    106.5068588256836,
                    105.60597229003906,
                    -1.216935396194458
                ]
            ],
            "rightEyeLower2": [
                [
                    72.9649658203125,
                    109.90436553955078,
                    11.854694366455078
                ],
                [
                    74.2219009399414,
                    115.15513610839844,
                    10.611681938171387
                ],
                [
                    77.0810317993164,
                    117.59391021728516,
                    7.667500972747803
                ],
                [
                    82.46488952636719,
                    119.22377014160156,
                    4.087185859680176
                ],
                [
                    89.41935729980469,
                    119.13565826416016,
                    1.6742497682571411
                ],
                [
                    96.0038833618164,
                    117.74301147460938,
                    0.673589825630188
                ],
                [
                    101.08658599853516,
                    115.84601593017578,
                    0.2831626534461975
                ],
                [
                    104.59732055664062,
                    113.9703140258789,
                    -0.14186634123325348
                ],
                [
                    107.33145141601562,
                    110.96194458007812,
                    -1.1111698150634766
                ]
            ],
            "rightEyeLower3": [
                [
                    64.23298645019531,
                    112.30160522460938,
                    22.31523323059082
                ],
                [
                    68.86351013183594,
                    119.2115478515625,
                    14.128241539001465
                ],
                [
                    72.44051361083984,
                    123.27689361572266,
                    8.991997718811035
                ],
                [
                    79.17036437988281,
                    125.41738891601562,
                    3.621450185775757
                ],
                [
                    89.11593627929688,
                    124.43283081054688,
                    0.8515294194221497
                ],
                [
                    96.3904800415039,
                    121.96058654785156,
                    -0.5027655363082886
                ],
                [
                    101.8059310913086,
                    119.2264175415039,
                    -2.2888076305389404
                ],
                [
                    105.87271118164062,
                    116.21245574951172,
                    -3.3605034351348877
                ],
                [
                    108.96925354003906,
                    111.89136505126953,
                    -5.281299114227295
                ]
            ],
            "rightEyebrowUpper": [
                [
                    65.83094787597656,
                    102.6583251953125,
                    15.952875137329102
                ],
                [
                    67.89541625976562,
                    95.14932250976562,
                    8.388497352600098
                ],
                [
                    72.86251068115234,
                    90.24124145507812,
                    0.07799241691827774
                ],
                [
                    81.13420867919922,
                    87.73043060302734,
                    -6.5636701583862305
                ],
                [
                    92.08367156982422,
                    88.34381866455078,
                    -12.233930587768555
                ],
                [
                    104.74893188476562,
                    89.6520004272461,
                    -15.053000450134277
                ],
                [
                    106.61902618408203,
                    97.25012969970703,
                    -12.143393516540527
                ],
                [
                    111.07872772216797,
                    105.31053924560547,
                    -8.91411018371582
                ]
            ],
            "rightEyebrowLower": [
                [
                    68.36598205566406,
                    111.36668395996094,
                    16.3133487701416
                ],
                [
                    69.34245300292969,
                    104.0033950805664,
                    9.942222595214844
                ],
                [
                    70.95252990722656,
                    97.91282653808594,
                    3.352301597595215
                ],
                [
                    75.81651306152344,
                    94.27057647705078,
                    -2.683871269226074
                ],
                [
                    83.1146469116211,
                    92.69861602783203,
                    -7.434006690979004
                ],
                [
                    93.18150329589844,
                    93.332275390625,
                    -10.738887786865234
                ]
            ],
            "leftEyeUpper0": [
                [
                    156.50816345214844,
                    107.17440795898438,
                    6.463142395019531
                ],
                [
                    154.88734436035156,
                    106.20946502685547,
                    4.306293487548828
                ],
                [
                    152.0496368408203,
                    104.87964630126953,
                    2.195375442504883
                ],
                [
                    147.45089721679688,
                    104.04034423828125,
                    0.5978397727012634
                ],
                [
                    142.81710815429688,
                    104.25692749023438,
                    0.2953520715236664
                ],
                [
                    138.20118713378906,
                    105.53400421142578,
                    1.3848233222961426
                ],
                [
                    135.01080322265625,
                    107.61424255371094,
                    2.7306060791015625
                ]
            ],
            "leftEyeLower0": [
                [
                    157.78128051757812,
                    107.9542007446289,
                    9.194131851196289
                ],
                [
                    155.95977783203125,
                    109.22726440429688,
                    7.334073066711426
                ],
                [
                    153.84779357910156,
                    110.1096420288086,
                    5.69104528427124
                ],
                [
                    150.7473907470703,
                    110.93775939941406,
                    3.7676494121551514
                ],
                [
                    146.12115478515625,
                    111.42359161376953,
                    2.2459464073181152
                ],
                [
                    141.6517791748047,
                    111.0348892211914,
                    1.867456316947937
                ],
                [
                    137.45309448242188,
                    110.12110900878906,
                    2.602623462677002
                ],
                [
                    134.82908630371094,
                    109.65119934082031,
                    3.724750280380249
                ],
                [
                    133.61578369140625,
                    109.1581039428711,
                    3.78249192237854
                ]
            ],
            "leftEyeUpper1": [
                [
                    159.0517120361328,
                    105.50051879882812,
                    6.624624252319336
                ],
                [
                    156.50238037109375,
                    103.79371643066406,
                    2.9880430698394775
                ],
                [
                    153.13783264160156,
                    102.22638702392578,
                    0.3153851628303528
                ],
                [
                    148.0469512939453,
                    101.52294158935547,
                    -1.762386679649353
                ],
                [
                    142.4116668701172,
                    101.71417999267578,
                    -1.8313332796096802
                ],
                [
                    137.42381286621094,
                    103.12054443359375,
                    0.04886084049940109
                ],
                [
                    132.69496154785156,
                    106.45590209960938,
                    1.4397248029708862
                ]
            ],
            "leftEyeLower1": [
                [
                    159.28594970703125,
                    108.41778564453125,
                    10.382974624633789
                ],
                [
                    157.6327667236328,
                    111.36378479003906,
                    8.357008934020996
                ],
                [
                    155.27586364746094,
                    113.33280944824219,
                    5.952434539794922
                ],
                [
                    151.01254272460938,
                    114.33756256103516,
                    3.355182409286499
                ],
                [
                    145.976318359375,
                    114.58908081054688,
                    1.6804367303848267
                ],
                [
                    140.69699096679688,
                    114.11424255371094,
                    1.2109861373901367
                ],
                [
                    136.27047729492188,
                    112.68612670898438,
                    1.6222927570343018
                ],
                [
                    133.5114288330078,
                    111.29006958007812,
                    2.3601605892181396
                ],
                [
                    131.71080017089844,
                    109.6417465209961,
                    2.8075015544891357
                ]
            ],
            "leftEyeUpper2": [
                [
                    162.06199645996094,
                    104.83332061767578,
                    8.25685977935791
                ],
                [
                    160.0244598388672,
                    101.05924224853516,
                    2.857253074645996
                ],
                [
                    155.8155975341797,
                    99.07466125488281,
                    -1.116007685661316
                ],
                [
                    149.6817169189453,
                    98.49995422363281,
                    -3.7846388816833496
                ],
                [
                    142.2752227783203,
                    99.06980895996094,
                    -4.309804439544678
                ],
                [
                    133.6039581298828,
                    101.5875244140625,
                    -3.07625675201416
                ],
                [
                    129.3566131591797,
                    105.59530639648438,
                    -0.9609823226928711
                ]
            ],
            "leftEyeLower2": [
                [
                    162.7498321533203,
                    109.69417572021484,
                    12.883472442626953
                ],
                [
                    161.62667846679688,
                    114.84622955322266,
                    11.560099601745605
                ],
                [
                    158.8791046142578,
                    117.33142852783203,
                    8.646967887878418
                ],
                [
                    153.6244354248047,
                    118.95820617675781,
                    4.919290542602539
                ],
                [
                    146.71292114257812,
                    118.95172119140625,
                    2.355144739151001
                ],
                [
                    140.10670471191406,
                    117.60516357421875,
                    1.1949496269226074
                ],
                [
                    134.98941040039062,
                    115.74888610839844,
                    0.6643215417861938
                ],
                [
                    131.4561767578125,
                    113.90116119384766,
                    0.16929467022418976
                ],
                [
                    128.65235900878906,
                    110.94033813476562,
                    -0.8218579292297363
                ]
            ],
            "leftEyeLower3": [
                [
                    171.39910888671875,
                    111.9096450805664,
                    23.570072174072266
                ],
                [
                    167.0068359375,
                    118.77996826171875,
                    15.234307289123535
                ],
                [
                    163.63775634765625,
                    122.85443878173828,
                    10.01909351348877
                ],
                [
                    157.08656311035156,
                    125.0364990234375,
                    4.479675769805908
                ],
                [
                    147.17445373535156,
                    124.16161346435547,
                    1.5277549028396606
                ],
                [
                    139.84307861328125,
                    121.77812194824219,
                    0.0027251075953245163
                ],
                [
                    134.36807250976562,
                    119.108154296875,
                    -1.9097141027450562
                ],
                [
                    130.26846313476562,
                    116.13423156738281,
                    -3.0669960975646973
                ],
                [
                    127.07047271728516,
                    111.85054016113281,
                    -5.076536178588867
                ]
            ],
            "leftEyebrowUpper": [
                [
                    169.7152862548828,
                    102.39374542236328,
                    17.10785484313965
                ],
                [
                    167.5852508544922,
                    95.07487487792969,
                    9.425344467163086
                ],
                [
                    162.63259887695312,
                    90.31060791015625,
                    0.986547589302063
                ],
                [
                    154.4151611328125,
                    87.81568908691406,
                    -5.846424579620361
                ],
                [
                    143.57244873046875,
                    88.45161437988281,
                    -11.77291488647461
                ],
                [
                    130.9725341796875,
                    89.73095703125,
                    -14.795687675476074
                ],
                [
                    129.21762084960938,
                    97.3161849975586,
                    -11.966418266296387
                ],
                [
                    124.80030059814453,
                    105.3028335571289,
                    -8.767714500427246
                ]
            ],
            "leftEyebrowLower": [
                [
                    167.32241821289062,
                    111.04369354248047,
                    17.4151554107666
                ],
                [
                    166.27719116210938,
                    103.80069732666016,
                    11.055558204650879
                ],
                [
                    164.63258361816406,
                    97.86701965332031,
                    4.355432033538818
                ],
                [
                    159.76461791992188,
                    94.31718444824219,
                    -1.8263874053955078
                ],
                [
                    152.53158569335938,
                    92.80870819091797,
                    -6.7318196296691895
                ],
                [
                    142.52125549316406,
                    93.40934753417969,
                    -10.279659271240234
                ]
            ],
            "midwayBetweenEyes": [
                [
                    117.91822814941406,
                    104.27511596679688,
                    -13.102889060974121
                ]
            ],
            "noseTip": [
                [
                    118.52294158935547,
                    143.6044921875,
                    -31.441082000732422
                ]
            ],
            "noseBottom": [
                [
                    118.57138061523438,
                    149.10800170898438,
                    -15.925427436828613
                ]
            ],
            "noseRightCorner": [
                [
                    103.0930404663086,
                    147.16693115234375,
                    -8.347593307495117
                ]
            ],
            "noseLeftCorner": [
                [
                    133.92514038085938,
                    146.8848419189453,
                    -8.02297592163086
                ]
            ],
            "rightCheek": [
                [
                    83.78854370117188,
                    144.54547119140625,
                    -0.9838578104972839
                ]
            ],
            "leftCheek": [
                [
                    153.1754608154297,
                    144.14674377441406,
                    -0.3275127112865448
                ]
            ]
        }
    }
]
